<template>
    <div>
        <div id="link-view" style="display: none;"></div>
        <div id="close-view" style="display: none;"></div>
        <div v-if="apiFailed" class="app-error-info">
            <img src="../assets/images/icon_server_down.svg" />
            <div>
                Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.
            </div>
        </div>
        <div v-if="str"
            v-show="designAvailable" 
            class="app-container"
            :style="{'background-color': config.backgroundImage ? 'transparent' : config.backgroundColor, 'color': config.textColor}"
            :class="[config.font ? ('app-container-font-' + config.font) : '']"
        >
            <div v-if="config.design && (config.title || config.design !== 'steps')" class="app-title-container">
                <div class="app-screen-title text-bold">
                    {{ config.title }}
                </div>
                <div v-if="!config.sendLater && !config.saveInFooter && !config.footerButtons && config.design && config.design !== 'steps'" class="app-title-icon" @click="save()">
                    <img src="../assets/images/icon_save.svg" />
                </div>
            </div>

            <div v-if="config.design === 'tabs' && config.steps && config.steps.length > 1" class="app-tabs">
                <div v-for="(step, index) in config.steps" :key="index"
                    @click="openStep(index)"
                    :style="getTabStyle(index)"
                >
                    <span>{{ step.name }}</span>
                </div>
            </div>

            <div v-if="config.design === 'arrows_top'" class="app-arrows-top">
                <div @click="goToPreviousStep()" class="app-arrows-icon">
                    <i class="fa fa-chevron-left"></i>
                </div>
                <div>
                    {{ config.steps[stepIndex].name }}
                </div>
                <div @click="goToNextStep()" class="app-arrows-icon">
                    <i class="fa fa-chevron-right"></i>
                </div>
            </div>

            <div v-if="config.design === 'arrows_bottom' && config.steps[stepIndex].name"
                class="app-arrows-title"
            >
                {{ config.steps[stepIndex].name }}
            </div>

            <div v-if="!successAfterSubmitVisible" class="app-content-scroll-element">
                <div
                    v-show="initialized"
                    :class="{'app-content-hidden': stepIndex !== currentIndex}"
                    v-for="(step, currentIndex) in config.steps"
                    :key="currentIndex"
                >
                    <div :class="{'app-content-hidden': stepIndex !== currentIndex}" class="app-content">
                        <div v-if="step.title" class="app-title text-bold" :style="config.titleStyles">
                            {{ step.title }}
                        </div>

                        <div v-if="step.subtitle" class="app-subtitle text-bold" v-html="step.subtitle" :style="config.subtitleStyles">
                        </div>

                        <div
                            v-if="step.clipboard"
                            class="app-clipboard"
                            :style="[config.clipboardStyles, step.clipboardStyles]"
                        >
                            <div
                                v-for="clipboardText in step.clipboard"
                                @click="copyTextToClipboard($event, str[clipboardText.text] ? str[clipboardText.text] : clipboardText.text)"
                            >
                                <b v-if="clipboardText.title">
                                    {{ str[clipboardText.title] ? str[clipboardText.title] : clipboardText.title }}:
                                </b>
                                <span>
                                    {{ str[clipboardText.text] ? str[clipboardText.text] : clipboardText.text }}
                                </span>
                                <span class="app-clipboard-icon">
                                    <i class="fa fa-clone" />
                                </span>
                            </div>
                        </div>

                        <div v-if="step.image" class="app-image">
                            <img :src="step.image" :style="{width: step.imageSize}" />
                        </div>

                        <div v-if="step.video" class="app-video">
                            <iframe
                                width="100%"
                                :height="step.videoSize ? step.videoSize : 300"
                                :src="step.video"
                                frameborder="0"
                            ></iframe>
                        </div>

                        <div v-if="step.info" class="app-info" v-html="step.info">
                        </div>

                        <div v-if="step.images" class="app-margin-space">
                            <v-carousel
                                :continuous="false"
                                :cycle="false"
                                hide-delimiters
                                style="box-shadow: none; outline: none; height: 200px;"
                            >
                                <v-carousel-item
                                    v-for="(img, index) in step.images"
                                    :key="index"
                                >
                                    <v-sheet
                                        height="200px"
                                        style="text-align: center; background-color: transparent;"
                                    >
                                        <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                            <img
                                                :src="img"
                                                style="max-width: 200px; max-height: 200px;"
                                            />
                                        </div>
                                    </v-sheet>
                                </v-carousel-item>
                            </v-carousel>
                        </div>

                        <div class="app-body">
                            <!-- Send audio or text checkbox -->
                            <div
                                v-if="step.sendAudioOrText"
                                class="form-row-switch"
                            >
                                <span>
                                    {{ str[step.sendAudioOrText.text] ? str[step.sendAudioOrText.text] : step.sendAudioOrText.text }}
                                </span>
                                <v-switch
                                    v-model="step.sendAudioOrText.value"
                                    color="success"
                                    hide-details
                                />
                            </div>
                            <!-- Fields -->
                            <div v-if="step.fields" :class="{'app-content-grid': hasGrid}">
                                <div
                                    v-for="(item, itemIndex) in step.fields"
                                    :key="itemIndex"
                                    class="form-row"
                                    v-show="checkItemCondition(step, item)"
                                    :class="[config.inputStyles, item.cols ? ('app-content-grid-cols-' + item.cols) : '', item.onlyParent ? 'form-row-only-parent' : '']"
                                >
                                    <span
                                        v-if="item.parent && !item.hideParent"
                                        class="form-row-title-parent"
                                        :style="{'padding': item.onlyParent ? '0' : ''}"
                                    >
                                        {{ item.parent }}
                                    </span>
                                    <span
                                        class="form-row-title"
                                        v-if="item.type !== 'checkbox' && !item.onlyParent"
                                        :class="config.fieldTitleClass"
                                        :style="{'justify-content': item.titleCentered ? 'center' : '', 'display': item.legend ? 'block' : ''}"
                                    >
                                        {{ item.title }}{{ item.showRequiredCharacter ? ' *' : '' }}
                                        <span
                                            v-if="item.legend"
                                            class="app-legend text-regular"
                                        >
                                            {{ item.legend }}
                                        </span>
                                        <span
                                            v-if="item.icon_info"
                                            style="padding: 0 10px;"
                                            @click="showInfo(item.icon_info)"
                                        >
                                            <i
                                                class="fa fa-info-circle"
                                                style="font-size: 20px;"
                                            />
                                        </span>
                                        <span
                                            v-if="item.infoVideo"
                                            style="padding: 0 10px;"
                                            @click="openVideo({name: item.title, video_url: item.infoVideo})"
                                        >
                                            <i
                                                class="fa fa-info-circle"
                                                style="font-size: 20px;"
                                            />
                                        </span>
                                    </span>
                                    <div
                                        v-if="item.type == 'audio'"
                                        class="audio-component"
                                    >
                                        <audio-recorder
                                            v-if="!item.value"
                                            :time="60"
                                            :item="item"
                                            :callback="saveAudio"
                                        />
                                        <audio
                                            v-if="item.value"
                                            controls
                                        >
                                            <source :src="item.value" type="audio/mp3">
                                        </audio>
                                        <img
                                            v-if="item.value"
                                            src="../assets/images/icon_delete.svg"
                                            class="ml-4 cursor-hover"
                                            @click="clearAudio(item)"
                                        />
                                    </div>
                                    <v-text-field
                                        v-if="item.type == 'input' && item.inputType != 'numeric' && item.inputType != 'integer'"
                                        v-model="item.value"
                                        :disabled="item.disabled ? true : false"
                                        hide-details
                                        outline
                                        rounded
                                        clearable
                                    />
                                    <v-text-field
                                        v-if="item.type == 'input' && item.inputType == 'numeric'"
                                        v-model="item.value"
                                        :disabled="item.disabled ? true : false"
                                        hide-details
                                        outline
                                        rounded
                                        clearable
                                        oninput="this.value = this.value.replace(/[^0-9.,]/g, '').replace(/([.,].*)[.,]/g, '$1');"
                                    />
                                    <v-text-field
                                        v-if="item.type == 'input' && item.inputType == 'integer'"
                                        v-model="item.value"
                                        :disabled="item.disabled ? true : false"
                                        hide-details
                                        outline
                                        rounded
                                        clearable
                                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                                    />
                                    <v-text-field
                                        v-if="item.type == 'input_mask'"
                                        v-model="item.value"
                                        :disabled="item.disabled ? true : false"
                                        hide-details
                                        outline
                                        rounded
                                        clearable
                                        return-masked-value
                                        :mask="item.mask"
                                    />
                                    <date-mask-input
                                        v-if="item.type == 'date_mask'"
                                        v-model="item.value"
                                        :disabled="item.disabled ? true : false"
                                        :only-previous-dates="!!item.onlyPreviousDates"
                                        @invalid="(invalid) => $set(item, 'dateMaskInvalid', invalid)"
                                    />
                                    <v-select
                                        v-if="item.type == 'select'"
                                        v-model="item.value"
                                        item-text="label"
                                        item-value="value"
                                        :items="item.items"
                                        :no-data-text="str['no_data']"
                                        hide-details
                                        outline
                                        @change="onChangeSelect(item)"
                                        append-icon="fa-caret-down"
                                    />
                                    <v-autocomplete
                                        v-if="item.type == 'select_search'"
                                        v-model="item.value"
                                        item-text="label"
                                        item-value="value"
                                        :items="item.items"
                                        :no-data-text="str['no_data']"
                                        hide-details
                                        outline
                                        @change="onChangeSelect(item)"
                                        append-icon="fa-caret-down"
                                    />
                                    <div
                                        v-if="item.type == 'select_search_dialog'"
                                        class="select-search"
                                        @click="openSelectSearch(item)"
                                    >
                                        <v-select
                                            :ref="'component-multiselect-' + item.id"
                                            v-model="item.value"
                                            item-text="label"
                                            item-value="value"
                                            :items="item.items"
                                            :no-data-text="str['no_data']"
                                            hide-details
                                            :label="item.outlineDisabled ? item.title : null"
                                            :outline="!item.outlineDisabled ? true : false"
                                            style="pointer-events: none;"
                                            append-icon="fa-caret-down"
                                        >
                                        </v-select>
                                        <v-dialog
                                            v-if="item.opened"
                                            ref="dialog"
                                            v-model="item.opened"
                                            width="95%"
                                            max-width="500"
                                            persistent
                                        >
                                            <v-card>
                                                <v-card-text
                                                    class="pt-2 pb-0"
                                                >
                                                    <v-text-field
                                                        v-model="selectSearchItemsSearch"
                                                        append-icon="mdi-magnify"
                                                        :label="str['search']"
                                                        single-line
                                                        hide-details
                                                        class="select-search-list-search pt-0 mt-0 mb-3"
                                                        clearable
                                                    />
                                                    <div
                                                        class="select-search-list"
                                                    >
                                                        <virtualized-list :items="selectSearchItemsFiltered" :item-height="42">
                                                            <template v-slot="{ item: mItem }">
                                                                <div
                                                                    class="checkbox-container checkbox-container-virtual-list"
                                                                    @click="selectItemSelectSearch(item, mItem)"
                                                                    :class="{'active': mItem.active}"
                                                                >
                                                                    <div>
                                                                        {{ mItem.label }}
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </virtualized-list>
                                                    </div>
                                                </v-card-text>
                                                <v-card-actions
                                                    class="pt-3 pb-3"
                                                    style="justify-content: center;"
                                                >
                                                    <v-btn
                                                        color="default"
                                                        @click="closeSelectSearch(item)"
                                                    >
                                                        {{ str['ok'] }}
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </div>
                                    <tags-input
                                        v-if="item.type == 'tags'"
                                        v-model="item.value"
                                        :existing-tags="item.items"
                                        id-field="value"
                                        text-field="label"
                                        :placeholder="item.placeholder ? str[item.placeholder] : ''"
                                        delete-on-backspace
                                        only-existing-tags
                                        typeahead
                                        :typeahead-max-results="3"
                                        typeahead-hide-discard
                                    />
                                    <v-select
                                        v-if="item.type == 'multiselect'"
                                        :ref="'component-multiselect-' + item.id"
                                        v-model="item.value"
                                        item-text="label"
                                        item-value="value"
                                        :items="item.items"
                                        :no-data-text="str['no_data']"
                                        hide-details
                                        :label="item.outlineDisabled ? item.title : null"
                                        :outline="!item.outlineDisabled ? true : false"
                                        multiple
                                        chips
                                        small-chips
                                        append-icon="fa-caret-down"
                                    >
                                        <template v-slot:prepend-item>
                                            <div
                                                @click="closeSelect(item.id)"
                                                class="component-select-close"
                                            >
                                                {{ str['ok'] }}
                                            </div>
                                            <v-divider class="mt-2"></v-divider>
                                        </template>
                                    </v-select>
                                    <div
                                        v-if="item.type == 'multiselect_search'"
                                        class="multiselect-search"
                                        @click="openSelectSearch(item)"
                                    >
                                        <v-select
                                            :ref="'component-multiselect-' + item.id"
                                            v-model="item.value"
                                            item-text="label"
                                            item-value="value"
                                            :items="item.items"
                                            :no-data-text="str['no_data']"
                                            hide-details
                                            :label="item.outlineDisabled ? item.title : null"
                                            :outline="!item.outlineDisabled ? true : false"
                                            multiple
                                            chips
                                            small-chips
                                            style="pointer-events: none;"
                                            append-icon="fa-caret-down"
                                        >
                                        </v-select>
                                        <v-dialog
                                            v-if="item.opened"
                                            ref="dialog"
                                            v-model="item.opened"
                                            width="95%"
                                            max-width="500"
                                            persistent
                                        >
                                            <v-card>
                                                <v-card-text
                                                    class="pt-2 pb-0"
                                                >
                                                    <v-text-field
                                                        v-model="selectSearchItemsSearch"
                                                        append-icon="mdi-magnify"
                                                        :label="str['search']"
                                                        single-line
                                                        hide-details
                                                        class="select-search-list-search pt-0 mt-0 mb-3"
                                                        clearable
                                                    />
                                                    <div
                                                        class="select-search-list"
                                                    >
                                                        <virtualized-list :items="selectSearchItemsFiltered" :item-height="42">
                                                            <template v-slot="{ item: mItem }">
                                                                <div
                                                                    class="checkbox-container checkbox-container-virtual-list"
                                                                    :class="{'disabled': mItem.disabled}"
                                                                    @click="selectItemSelectSearch(item, mItem)"
                                                                >
                                                                    <div
                                                                        class="checkbox-container-box"
                                                                        :style="{'border-color': '#888', 'color': '#4caf50'}"
                                                                    >
                                                                        <div v-if="mItem.active">
                                                                            <i class="fa fa-check"></i>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        {{ mItem.label }}
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </virtualized-list>
                                                    </div>
                                                </v-card-text>
                                                <v-card-actions
                                                    class="pt-3 pb-3"
                                                    style="justify-content: center;"
                                                >
                                                    <v-btn
                                                        color="default"
                                                        @click="closeSelectSearch(item)"
                                                    >
                                                        {{ str['cancel'] }}
                                                    </v-btn>
                                                    <v-btn
                                                        color="success"
                                                        @click="confirmSelectSearch(item)"
                                                    >
                                                        {{ str['confirm'] }}
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </div>
                                    <div
                                        v-if="item.type == 'radio_button'"
                                        class="radio-group"
                                    >
                                        <label
                                            v-for="option in item.items"
                                            :key="option.value"
                                            class="radio-label"
                                        >
                                            <input
                                                type="radio"
                                                :name="itemIndex"
                                                :value="option.value"
                                                :checked="option.value === item.value"
                                                @change="item.value = option.value"
                                                class="radio-input"
                                            />
                                            <span class="radio-custom"></span>
                                            {{ option.label }}
                                        </label>
                                    </div>
                                    <div v-if="item.type == 'datepicker'">
                                        <v-dialog
                                            ref="dialog"
                                            v-model="datepicker[item.id]"
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="item.value"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    hide-details
                                                    outline
                                                    rounded
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-if="item.id == 'birth_date' && !item.value"
                                                v-model="defaultBirthDate"
                                                :max="item.id == 'birth_date' ? currentDate: null"
                                                style="margin: 0;"
                                                @change="changeDatepicker(item, $event)"
                                                :locale="datepickerLanguage"
                                                no-title
                                            >
                                            </v-date-picker>
                                            <v-date-picker
                                                v-if="item.id != 'birth_date' || (item.id == 'birth_date' && item.value)"
                                                v-model="item.value"
                                                :max="item.id == 'birth_date' ? currentDate: null"
                                                style="margin: 0;"
                                                @change="changeDatepicker(item, $event)"
                                                :locale="datepickerLanguage"
                                                no-title
                                            >
                                            </v-date-picker>
                                        </v-dialog>
                                    </div>
                                    <div
                                        v-if="item.type == 'datepicker_inline'"
                                        class="form-row-datepicker-inline"
                                    >
                                        <scroll-picker
                                            :options="getDays()"
                                            v-model="datepickerInline.day"
                                            @input="changeDatepickerInline(item)"
                                        ></scroll-picker>
                                        <scroll-picker
                                            :options="getMonths()"
                                            v-model="datepickerInline.month"
                                            @input="changeDatepickerInline(item)"
                                        ></scroll-picker>
                                        <scroll-picker
                                            :options="getYears()"
                                            v-model="datepickerInline.year"
                                            @input="changeDatepickerInline(item)"
                                        ></scroll-picker>
                                    </div>
                                    <div v-if="item.type == 'timepicker'">
                                        <v-dialog
                                            ref="dialog"
                                            v-model="timepicker[item.id]"
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="item.value"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    hide-details
                                                    outline
                                                    rounded
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="timepicker[item.id]"
                                                v-model="item.value"
                                                format="24hr"
                                                @change="changeTimepicker($event, item)"
                                                :locale="datepickerLanguage"
                                                no-title
                                            ></v-time-picker>
                                        </v-dialog>
                                    </div>
                                    <div v-if="item.type == 'timepicker_inline'">
                                        <timepicker-inline
                                            :value="item.value"
                                            :item="item"
                                            :callback="updateTimepickerInlineValue"
                                        />
                                    </div>
                                    <v-textarea
                                        v-if="item.type == 'textarea'"
                                        v-model="item.value"
                                        :name="Math.random()"
                                        hide-details
                                        outlined
                                        rounded
                                    ></v-textarea>
                                    <div
                                        v-if="item.type == 'slider'"
                                        class="input-slider"
                                        :class="{'input-slider-custom': item.thumbInactiveColor}"
                                    >
                                        <v-slider
                                            v-model="item.value"
                                            :color="item.thumbActiveColor"
                                            :thumb-color="item.thumbInactiveColor"
                                            :track-color="item.thumbInactiveColor"
                                            :step="item.step"
                                            :min="item.minValue"
                                            :max="item.maxValue"
                                            hide-details
                                        ></v-slider>
                                        <div class="input-slider-legend">
                                            <div class="input-slider-legend-label">
                                                <div v-if="item.minLabel">
                                                    {{ str[item.minLabel] ? str[item.minLabel] : item.minLabel }}
                                                </div>
                                            </div>
                                            <div class="input-slider-legend-value">
                                                <div
                                                    class="input-slider-legend-value-circle"
                                                    :style="{color: item.valueTextColor, backgroundColor: item.valueTextBackgroundColor}"
                                                >
                                                    {{ item.value }}
                                                </div>
                                            </div>
                                            <div class="input-slider-legend-label">
                                                <div v-if="item.maxLabel">
                                                    {{ str[item.maxLabel] ? str[item.maxLabel] : item.maxLabel }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="item.type == 'scale'"
                                        class="input-scale"
                                    >
                                        <div
                                            v-if="item.minLabel"
                                            class="input-scale-label"
                                            :style="{'min-width': item.minLabelWidth, 'width': item.minLabelWidth, 'max-width': item.minLabelWidth}"
                                        >
                                            {{ str[item.minLabel] ? str[item.minLabel] : item.minLabel }}
                                        </div>
                                        <v-radio-group
                                            v-model="item.value"
                                            hide-details
                                            outline
                                        >
                                            <v-radio
                                                v-for="scaleItem in item.items"
                                                :key="scaleItem.value"
                                                :label="str[scaleItem.label] ? str[scaleItem.label] : scaleItem.label"
                                                :value="scaleItem.value"
                                            ></v-radio>
                                        </v-radio-group>
                                        <div
                                            v-if="item.maxLabel"
                                            class="input-scale-label"
                                            :style="{'min-width': item.maxLabelWidth, 'width': item.maxLabelWidth, 'max-width': item.maxLabelWidth}"
                                        >
                                            {{ str[item.maxLabel] ? str[item.maxLabel] : item.maxLabel }}
                                        </div>
                                    </div>
                                    <div v-if="item.type === 'checkbox'" class="checkbox-container">
                                        <div
                                            @click="onChangeCheckbox(item)"
                                            class="checkbox-container-box"
                                            :style="{ 'border-color': config.textColor, color: config.textColor }"
                                        >
                                            <div v-if="item.value">
                                                <i class="fa fa-check"></i>
                                            </div>
                                        </div>
                                        <div @click="onChangeCheckbox(item)">
                                            {{ item.title }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="item.type == 'buttons'"
                                        class="form-row-field-buttons"
                                    >
                                        <div
                                            v-for="buttonOpt in item.items"
                                        >
                                            <div
                                                @click="selectButtonOption(item, buttonOpt.value)"
                                                class="form-row-field-button"
                                                :class="{'form-row-field-button-active': item.value === buttonOpt.value}"
                                                :style="{backgroundImage: item.buttonBackground ? 'url(' + item.buttonBackground + ')' : ''}"
                                            >
                                                <img
                                                    v-if="buttonOpt.image"
                                                    :src="buttonOpt.image"
                                                />
                                                <div
                                                    v-if="!buttonOpt.image && buttonOpt.label"
                                                    v-html="str[buttonOpt.label] ? str[buttonOpt.label] : buttonOpt.label"
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="item.type == 'slider_horizontal'"
                                        class="form-row-field-slider-horizontal"
                                    >
                                        <vueper-slides
                                            class="no-shadow"
                                            :visible-slides="3"
                                            :gap="3"
                                            :bullets="false"
                                            @slide="changeSlide(item, $event)"
                                            :init-slide="item.initSlide"
                                        >
                                            <vueper-slide
                                                v-for="(buttonOpt, buttonOptIndex) in item.items"
                                                :key="buttonOptIndex"
                                            >
                                                <template #content>
                                                    <div
                                                        class="form-row-field-button form-row-field-button-slider"
                                                        :class="{'form-row-field-button-active': item.value === buttonOpt.value}"
                                                        :style="{backgroundImage: item.buttonBackground ? 'url(' + item.buttonBackground + ')' : ''}"
                                                    >
                                                        <img
                                                            v-if="buttonOpt.image"
                                                            :src="buttonOpt.image"
                                                        />
                                                        <div
                                                            v-if="!buttonOpt.image && buttonOpt.label"
                                                            v-html="str[buttonOpt.label] ? str[buttonOpt.label] : buttonOpt.label"
                                                        ></div>
                                                    </div>
                                                </template>
                                            </vueper-slide>
                                        </vueper-slides>
                                    </div>
                                    <video-element
                                        v-if="item.type == 'video'"
                                        :callback="receiveVideo"
                                        :video="item.value"
                                        :argument="{item: item}"
                                    />
                                    <div v-if="item.average && getAverageValue(step.fields, item)" class="form-row-field-average">
                                        {{ str['average']}} = {{ getAverageValue(step.fields, item) }}
                                    </div>
                                </div>
                            </div>
                            <!-- Add photos -->
                            <div v-if="step.id === 'photos'" class="app-margin-space">
                                <div v-for="(photo, index) in step.photos" :key="index">
                                    <div v-if="step.photosCaptions && step.photosCaptions[index]" class="form-row-photo-caption">
                                        {{ str[step.photosCaptions[index]] ? str[step.photosCaptions[index]] : step.photosCaptions[index] }}
                                    </div>
                                    <photo :callback="receivePhoto" :argument="index" :photo="photo" />
                                </div>
                            </div>
                            <!-- Add videos -->
                            <div v-if="step.id === 'videos'" class="app-margin-space">
                                <div v-for="(video, index) in step.videos" :key="index">
                                    <video-element :callback="receiveVideo" :argument="index" :video="video" />
                                </div>
                            </div>
                            <!-- Add proof -->
                            <div v-if="step.id === 'proof'" class="app-margin-space">
                                <div v-for="(photo, index) in step.photos" :key="index">
                                    <photo :callback="receivePhoto" :argument="index" :photo="photo" />
                                </div>
                            </div>
                             <!-- Select and go to specific step -->
                            <div v-if="step.goToStep" class="app-buttons-flex">
                                <div 
                                    v-for="(buttonElement, buttonIndex) in step.buttons"
                                    :key="buttonIndex"
                                    @click="nextStep(buttonElement.step, buttonElement.hideStep)"
                                    :style="getButtonStyle(buttonElement)"
                                    class="v-btn"
                                >
                                    {{ buttonElement.text }}
                                </div>
                            </div>
                            <!-- Html content -->
                            <div v-if="step.type === 'html'">
                                <div v-html="config[step.id]"></div>
                            </div>
                            <!-- Checkbox -->
                            <div v-if="step.checkbox" class="row" style="margin-top: 0; margin-bottom: 20px">
                                <div class="checkbox-container">
                                    <div
                                        @click="step.checkbox.value = !step.checkbox.value"
                                        class="checkbox-container-box"
                                        :style="{ 'border-color': config.textColor, color: config.textColor }"
                                    >
                                        <div v-if="step.checkbox.value">
                                            <i class="fa fa-check"></i>
                                        </div>
                                    </div>
                                    <div @click="step.checkbox.value = !step.checkbox.value">
                                        {{ str[step.checkbox.text] ? str[step.checkbox.text] : step.checkbox.text }}
                                    </div>
                                </div>
                                <a v-if="step.checkbox.url" @click.stop="openLinkUrl(step.checkbox.url)" class="nav-link">
                                    {{ str[step.checkbox.linkText] ? str[step.checkbox.linkText] : step.checkbox.linkText }}
                                </a>
                            </div>
                            <!-- Webview content -->
                            <div v-if="step.type === 'webview'">
                                <iframe
                                    v-if="step.url"
                                    :src="step.url"
                                    style="width: 100%; height: calc(100vh - 150px);"
                                />
                            </div>
                        </div>

                        <div v-if="config.footerButtons" class="app-footer" :style="config.footerStyles">
                            <div v-for="(button, index) in config.footerButtons" :key="index">
                                <v-btn
                                    @click="handleFooterButton(button.action)"
                                    :class="{'app-button-next': button.action === 'save' || button.action === 'next', 'app-button-back': button.action === 'back'}"
                                >
                                    {{ str[button.text] ? str[button.text] : button.text }}
                                </v-btn>
                            </div>
                        </div>

                        <div
                            v-if="config.design === 'steps' && !hideButtons"
                            class="app-footer"
                            :style="config.footerStyles"
                        >
                            <div v-if="currentIndex < config.steps.length - 1 && !step.goToStep">
                                <v-btn @click="nextStep()" class="app-button-next">
                                    {{ str['next'] }}
                                </v-btn>
                            </div>
                            <div v-if="config.sendLater && !step.hideSendLater">
                                <v-btn @click="save(true)"
                                    :style="getSendButtonStyle(true)">
                                    {{ str['save_send_later'] }}
                                </v-btn>
                            </div>
                            <div v-if="currentIndex === config.steps.length - 1">
                                <v-btn @click="save()" class="app-button-next">
                                    {{ str['finish'] }}
                                </v-btn>
                            </div>
                            <div v-if="currentIndex < config.steps.length - 1 || config.showBackLastStep">
                                <v-btn @click="backStep()" class="app-button-back">
                                    <i class="fa fa-chevron-left"></i>
                                    <span>
                                        {{ str['back'] }}
                                    </span>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="successAfterSubmitVisible">
                <div v-if="successAfterSubmitVisible.title" class="app-title text-bold" :style="config.titleStyles">
                    {{ str[successAfterSubmitVisible.title] ? str[successAfterSubmitVisible.title] : successAfterSubmitVisible.title }}
                </div>
                <div v-if="successAfterSubmitVisible.text" class="app-info">
                    {{ str[successAfterSubmitVisible.text] ? str[successAfterSubmitVisible.text] : successAfterSubmitVisible.text }}
                </div>
            </div>

            <div v-if="config.design === 'arrows_bottom' && initialized" class="app-arrows-bottom">
                <div @click="goToPreviousStep()" class="app-arrows-icon">
                    <i class="fa fa-chevron-left"></i>
                </div>
                <div class="app-arrows-bottom-points">
                    <div v-for="(step, index) in config.steps" :key="step.id"
                        :style="{'background-color': stepIndex === index ? config.circleActiveBackgroundColor : config.circleBackgroundColor}">
                    </div>
                </div>
                <div @click="goToNextStep()" class="app-arrows-icon">
                    <i class="fa fa-chevron-right"></i>
                </div>
            </div>

            <div
                v-if="(config.sendLater || config.saveInFooter) && config.design && config.design !== 'steps' && initialized"
                class="app-footer-buttons"
            >
                <v-btn v-if="config.sendLater && !onlySaveLater"
                    @click="save(true)"
                    :style="getSendButtonStyle(true)">
                    {{ str['save_send_later'] }}
                </v-btn>
                <v-btn v-if="onlySaveLater"
                    @click="save(true)"
                    :style="getSendButtonStyle(false)">
                    {{ str['save'] }}
                </v-btn>
                <v-btn v-if="!onlySaveLater" @click="save()"
                    :style="getSendButtonStyle(false)">
                    {{ str['send'] }}
                </v-btn>
            </div>
        </div>

        <v-dialog v-if="videoOpened" v-model="dialogVideo" persistent width="500px" max-width="90%">
            <v-card>
                <v-card-title
                    v-if="videoOpened.name"
                    style="display: flex; justify-content: center;"
                >
                    <div class="headline">
                        {{ videoOpened.name }}
                    </div>
                </v-card-title>
                <v-card-text style="padding: 0 10px;">
                    <iframe 
                        :src="videoOpened.video_url" 
                        width="100%" 
                        height="500" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowfullscreen
                        style="max-width: 100%; height: 60vh; border-radius: 8px;"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="default" @click="closeVideo">
                        {{ str['close'] }}
                    </v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Api from '../services/Api'
    import Utils from '../services/Utils'
    import Photo from '@/components/Photo'
    import VideoElement from '@/components/Video'
    import AudioRecorder from '@/components/AudioRecorder'
    import TimepickerInline from '@/components/TimepickerInline'
    import DateMaskInput from '@/components/DateMaskInput'
    import VirtualizedList from "vue-virtualized-list"
    import moment from 'moment'

    export default {
        components: {
            Photo,
            VideoElement,
            AudioRecorder,
            TimepickerInline,
            VirtualizedList,
            DateMaskInput,
        },
        data() {
            return {
                str: {},
                apiFailed: false,
                stepIndex: 0,
                openedByApp: window.openedByApp,
                designAvailable: false,
                initialized: false,
                processing: false,
                datepicker: {},
                timepicker: {},
                defaultBirthDate: Utils.getDefaultBirthDate(),
                datepickerLanguage: window.datepickerLanguage,
                currentDate: Utils.getFormatDate(),
                config: {},
                openedSteps: [],
                requestsDone: {},
                sendLater: null,
                physicalEvaluationToSave: null,
                status: {
                    sendNow: 0,
                    validated: 1,
                    initialQuiz: 2,
                    sendLater: 3,
                },
                datepickerInline: {
                    year: (new Date()).getFullYear() - 18,
                    month: 1,
                    day: 1,
                },
                selectSearchItems: [],
                selectSearchItemsSearch: '',
                hideButtons: false,
                successAfterSubmitVisible: false,
                videoOpened: null,
                dialogVideo: false,
                hasGrid: false,
                onlySaveLater: window.filterKey ? true : false,
            }
        },
        computed: {
            selectSearchItemsFiltered() {
                return this.selectSearchItems.filter(item => {
                    return !this.selectSearchItemsSearch || item.label.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(this.selectSearchItemsSearch.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase()) > -1
                })
            },
        },
        beforeMount: function () {
            this.getStrings()
        },
        methods: {
            getFillStyle: function (solidColor, gradientColors) {
                return Utils.getButtonBackgroundStyle(solidColor, gradientColors)
            },
            getTabStyle: function (index) {
                const active = this.stepIndex === index
                return Object.assign(
                    this.getFillStyle(
                        active ? this.config.tabActiveBackgroundColor : this.config.tabBackgroundColor,
                        active ? this.config.tabActiveBackgroundGradient : this.config.tabBackgroundGradient,
                    ),
                    {
                        color: active ? this.config.tabActiveTextColor : this.config.tabTextColor,
                        borderRadius:
                            index === 0 || index === this.config.steps.length - 1
                                ? this.config.tabRadius + 'px'
                                : 0,
                        lineHeight: this.config.tabLineHeight,
                    },
                )
            },
            getButtonStyle: function (buttonElement) {
                return Object.assign(
                    {
                        color: buttonElement.textColor,
                    },
                    this.getFillStyle(buttonElement.backgroundColor, buttonElement.backgroundGradient),
                )
            },
            getSendButtonStyle: function (later) {
                if (later) {
                    return Object.assign(
                        {
                            color: this.config.buttonSendLaterTextColor,
                        },
                        this.getFillStyle(
                            this.config.buttonSendLaterBackgroundColor,
                            this.config.buttonSendLaterBackgroundGradient,
                        ),
                    )
                }
                return Object.assign(
                    {
                        color: this.config.buttonSendTextColor,
                    },
                    this.getFillStyle(this.config.buttonSendBackgroundColor, this.config.buttonSendBackgroundGradient),
                )
            },
            getStrings: function () {
                const self = this
                this.apiFailed = false
                Api.getStrings(function (response) {
                    if (response.success) {
                        window.strings = response.data
                        self.str = response.data
                        self.main()
                    } else {
                        self.apiFailed = true
                    }
                })
            },
            main: function () {
                const self = this
                this.$isLoading(true)
                Utils.refreshAppUrl()
                Api.getEnums(function () {
                    Api.getConfig(function (response) {
                        if (response.success) {
                            self.refreshData(response.data)
                        } else {
                            self.$isLoading(false)
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                        }
                    })
                })
            },
            refreshData: function (config) {
                if (!this.openedByApp && config.externalBackgroundColor) {
                    config.backgroundColor = config.externalBackgroundColor
                }
                Utils.setConfigStrings(config)
                this.config = config
                Utils.refreshAppUrl(this.config)
                this.checkFilterKey()
                this.disablePackFormIds()
                this.checkHasGrid()
                this.getUser()
                this.refreshDesign()
                this.handleUserValidation()
            },
            checkFilterKey: function () {
                try {
                    if (window.filterKey) {
                        delete this.config.title
                        this.config.steps = this.config.steps.filter(step => step.fields &&step.fields.some(field => field.filterKey === window.filterKey))
                        this.config.steps.forEach(step => {
                            if (step.fields) {
                                step.fields = step.fields.filter(field => field.filterKey === window.filterKey)
                            }
                        })
                    }
                } catch {}
            },
            disablePackFormIds: function () {
                try {
                    if (window.disablePackForm && this.config.steps) {
                        this.config.steps.forEach(step => {
                            if (step.pack_form_ids) {
                                delete step.pack_form_ids
                            }
                            if (step.fields) {
                                step.fields.forEach(field => {
                                    if (field.pack_form_ids) {
                                        delete field.pack_form_ids
                                    }
                                })
                            }
                        })
                    }
                } catch {}
            },
            checkHasGrid: function () {
                try {
                    if (this.config.steps) {
                        this.config.steps.forEach(step => {
                            if (step.fields) {
                                step.fields.forEach(field => {
                                    if (field.cols) {
                                        this.hasGrid = true
                                    }
                                })
                            }
                        })
                    }
                } catch {}
            },
            refreshDesign: function () {
                if (this.config.design !== 'steps') {
                    document.documentElement.classList.add('app-content-has-scroll')
                }
                this.designAvailable = true
            },
            handleUserValidation: function () {
                const self = this
                if (this.config.validateUser) {
                    this.$prompt(
                        window.strings[this.config.validateUser.text] ? window.strings[this.config.validateUser.text] : this.config.validateUser.text,
                        '',
                        '',
                        '',
                        {
                            confirmButtonText: window.strings['confirm'],
                            customClass: {
                                container: 'swal2-hide-cancel-button'
                            },
                            allowOutsideClick: false
                        }
                    ).then(value => {
                        if (self.config.validateUser.field === 'email') {
                            value = Utils.encodeEmail(value)
                        }
                        self.$isLoading(true)
                        Api.getUserByField({
                            field: self.config.validateUser.field,
                            value: value
                        }, function (response) {
                            self.$isLoading(false)
                            if (response.success && response.data[0] && response.data[0].id === window.clientId) {
                                return true
                            } else {
                                self.$alert(
                                    window.strings[self.config.validateUser.failedMessage] ? window.strings[self.config.validateUser.failedMessage] : self.config.validateUser.failedMessage,
                                    '',
                                    'warning',
                                    Utils.getAlertOptions()
                                ).then(() => {
                                    self.handleUserValidation()
                                })
                            }
                        })
                    }).catch(() => {
                        self.$alert(
                            self.config.validateUser.failedMessage,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        ).then(() => {
                            self.handleUserValidation()
                        })
                    })
                }
            },
            getUser: function () {
                const self = this
                if (window.clientId) {
                    Api.getUser({
                        id: window.clientId
                    }, function (response) {
                        if (response.success && response.data[0]) {
                            self.user = response.data[0]
                            self.checkPackFormsFields(function () {
                                self.handleCheckHasPlans(function () {
                                    self.getPhysicalEvaluationToSave()
                                    self.refreshForms()
                                    self.refreshPage()
                                })
                            })
                            self.handleGetEmployees()
                        } else {
                            self.$isLoading(false)
                            self.$alert(
                                response.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                        }
                    })
                } else {
                    self.$isLoading(false)
                    self.$alert(
                        self.str['client_id_not_sent'],
                        '',
                        'warning',
                        Utils.getAlertOptions()
                    )
                }
            },
            checkPackFormsFields: function (callback) {
                try {
                    if (this.user && this.user.pack_id) {
                        let hasPackFormIds = false
                        for (let s = 0; s < this.config.steps.length; s++) {
                            const step = this.config.steps[s]
                            if (step.pack_form_ids) {
                                hasPackFormIds = true
                                break
                            }
                            if (step.fields) {
                                for (let i = 0; i < step.fields.length; i++) {
                                    if (step.fields[i].pack_form_ids) {
                                        hasPackFormIds = true
                                        break
                                    }
                                }
                            }
                            if (hasPackFormIds) {
                                break
                            }
                        }
                        if (hasPackFormIds) {
                            return Api.getPaymentPack({
                                id: this.user.pack_id,
                                fields: ['id', 'form']
                            }, (response) => {
                                this.userPack = response.data && response.data[0] ? response.data[0] : null
                                if (this.userPack) {
                                    for (let i = this.config.steps.length - 1; i > -1; i--) {
                                        if (this.config.steps[i].pack_form_ids && !this.config.steps[i].pack_form_ids.includes(this.userPack.form)) {
                                            if (this.config.steps[i].json_last) {
                                                const lastIndex = this.config.steps.reduceRight((foundIndex, step, index) => {
                                                    if (foundIndex === -1 && step.json_increment && index !== i) {
                                                        return index
                                                    }
                                                    return foundIndex
                                                }, -1)
                                                this.config.steps[lastIndex].json_last = true
                                            }
                                            this.config.steps.splice(i, 1)
                                        }
                                    }
                                }
                                callback()
                            })
                        }
                    }
                } catch { }
                callback()
            },
            handleCheckHasPlans: function (callback) {
                const self = this
                if (this.config.checkHasNutritionPlan) {
                    return Api.getNutritionPlan(self.user.db_id, function (response) {
                        if (response.success && response.data && response.data[0]) {
                            self.user.has_nutrition_plan = true
                            getTrainingPlan()
                        } else {
                            Api.getOldNutritionPlan(self.user.db_id, function (response) {
                                if (response.success && response.data && response.data[0] && response.data[0].description) {
                                    self.user.has_nutrition_plan = true
                                } else {
                                    self.user.has_nutrition_plan = false
                                }
                                getTrainingPlan()
                            })
                        }

                        function getTrainingPlan() {
                            Api.getTrainingPlan(self.user.db_id, function (response) {
                                if (response.success && response.data && response.data[0] && response.data[0].days_count) {
                                    self.user.has_training_plan = true
                                } else {
                                    self.user.has_training_plan = false
                                }
                                callback()
                            })
                        }
                    })
                }
                callback()
            },
            handleGetEmployees: function () {
                try {
                    let needsGetEmployees = false
                    if (this.config && this.config.steps && this.user && (this.user.employee1 || this.user.employee2)) {
                        for (let s = 0; s < this.config.steps.length; s++) {
                            const step = this.config.steps[s]
                            if (step.fields) {
                                for (let f = 0; f < step.fields.length; f++) {
                                    if (step.fields[f].saveEmployee) {
                                        needsGetEmployees = true
                                        break
                                    }
                                }
                            }
                            if (needsGetEmployees) {
                                break
                            }
                        }
                    }
                    if (needsGetEmployees) {
                        Api.getEmployees({
                            ids: [this.user.employee1, this.user.employee2].filter(Boolean)
                        }, (response) => {
                            if (response.success && response.data && response.data.length) {
                                this.userEmployees = response.data
                            }
                        })
                    }
                } catch { }
            },
            getPhysicalEvaluationToSave: function () {
                const self = this
                if (window.getDataCallback) {
                    return Api.getPhysicalEvaluation({
                        client_id: this.user.db_id,
                        id: window.getDataCallback
                    }, function (response) {
                        self.$isLoading(false)
                        if (response.success && response.data && response.data.length) {
                            self.physicalEvaluationToSave = response.data[response.data.length - 1]
                            setData()
                        } else {
                            self.getDataCallbackReady(false)
                        }
                    })
                }
                if (window.physicalEvaluationToEdit) {
                    return Api.getPhysicalEvaluation({
                        client_id: this.user.db_id,
                        id: window.physicalEvaluationToEdit
                    }, function (response) {
                        self.$isLoading(false)
                        if (response.success && response.data && response.data.length) {
                            self.physicalEvaluationToSave = response.data[response.data.length - 1]
                            setData()
                        } else {
                            self.getDataCallbackReady(false)
                        }
                    })
                }
                if (self.config.sendLater || self.config.saveDailyWeight || self.config.saveDailyData || self.config.saveCardio) {
                    return Api.getPhysicalEvaluation({
                        client_id: this.user.db_id
                    }, function (response) {
                        self.$isLoading(false)
                        if (response.success && response.data && response.data.length) {
                            self.physicalEvaluationToSave = response.data[response.data.length - 1]
                            setData()
                        }
                    })
                }
                if (self.config.useAlerts) {
                    return Api.getAlerts({
                        client_id: this.user.id
                    }, function (response) {
                        if (response.data && response.data.daily_weekly_feedback_id) {
                            Api.getPhysicalEvaluation({
                                client_id: self.user.db_id,
                                id: response.data.daily_weekly_feedback_id
                            }, function (response) {
                                self.$isLoading(false)
                                if (response.success && response.data[0]) {
                                    self.physicalEvaluationToSave = response.data[0]
                                    setData()
                                }
                            })
                        } else {
                            self.$isLoading(false)
                        }
                    })
                }
                if (window.diary) {
                    return Api.getTypePhysicalEvaluation({
                        client_id: this.user.db_id
                    }, function (response) {
                        self.$isLoading(false)
                        if (response.success && response.data[0]) {
                            self.physicalEvaluationToSave = response.data[0]
                            setData()
                        }
                    })
                }
                self.$isLoading(false)

                function setData() {
                    try {
                        const dailyWeightDaysKeys = self.config.saveDailyWeight ? Utils.getDailyWeightDays().map(dw => dw.value) : null

                        if (self.physicalEvaluationToSave) {
                            const userData = self.user
                            const data = self.physicalEvaluationToSave
                            let questionsParse = null
                            let cardioData = null
                            try {
                                if (data && data.test && data.test.cardio) {
                                    cardioData = JSON.parse(data.test.cardio)
                                }
                            } catch {}

                            for (let s = 0; s < self.config.steps.length; s++) {
                                const step = self.config.steps[s]

                                if (step.json_string && step.fields) {
                                    for (let i = 0; i < step.fields.length; i++) {
                                        if (step.fields[i].save) {
                                            const stepId = step.fields[i].replaceId ? step.fields[i].replaceId : step.fields[i].id
                                            if (step.fields[i].saveQuestion) {
                                                if (!questionsParse) {
                                                    questionsParse = data.remarks && typeof data.remarks === 'string' ? JSON.parse(data.remarks) : data.remarks
                                                }
                                                if (questionsParse) {
                                                    const questionAnswerWithSameID = questionsParse.filter(function (q) {
                                                        return q.id === step.fields[i].id
                                                    })
                                                    let questionAnswer = questionAnswerWithSameID[0]
                                                    if (questionAnswerWithSameID.length > 1) {
                                                        questionAnswer = questionsParse.find(function (q) {
                                                            return q.id === step.fields[i].id && q.title === step.fields[i].title
                                                        })
                                                    }
                                                    if (questionAnswer && questionAnswer.value) {
                                                        if (step.fields[i].type === 'multiselect' || step.fields[i].type === 'multiselect_search') {
                                                            step.fields[i].value = questionAnswer.value.split(', ')
                                                            if (step.fields[i].value && step.fields[i].value.length) {
                                                                step.fields[i].needToConvertToId = true
                                                                if (step.fields[i].items && step.fields[i].items.length) {
                                                                    self.applyFieldsValuesConversions()
                                                                }
                                                            }
                                                        } else {
                                                            step.fields[i].value = questionAnswer.value
                                                            if (step.fields[i].items) {
                                                                step.fields[i].needToConvertToId = true
                                                                self.applyFieldsValuesConversions()
                                                            }
                                                        }
                                                    }
                                                }
                                            } else if (step.fields[i].parentId) {
                                                step.fields[i].value = data[step.fields[i].parentId][stepId] ? data[step.fields[i].parentId][stepId] : ''
                                            } else if (step.fields[i].updateUser && userData[step.fields[i].updateUser]) {
                                                if (step.fields[i].saveJsonId) {
                                                    let userDataParse = userData[step.fields[i].updateUser]
                                                    if (userDataParse) {
                                                        if (typeof userDataParse === 'string') {
                                                            userDataParse = JSON.parse(userDataParse)
                                                        }
                                                        step.fields[i].value = userDataParse[step.fields[i].saveJsonId]
                                                    }
                                                } else {
                                                    step.fields[i].value = userData[step.fields[i].updateUser]
                                                }
                                            } else {
                                                const parseData = typeof data[step.id] === 'string' ? JSON.parse(data[step.id]) : data[step.id]
                                                const itemData = parseData.find(function (it) {
                                                    return it.id === step.fields[i].id
                                                })
                                                if (itemData && itemData.value) {
                                                    if ((step.fields[i].type === 'multiselect' || step.fields[i].type === 'multiselect_search') && typeof itemData.value === 'string') {
                                                        const split = itemData.value.split(', ')
                                                        step.fields[i].value = split.length ? split : itemData.value
                                                    } else {
                                                        step.fields[i].value = itemData.value
                                                    }
                                                }
                                            }
                                            if (dailyWeightDaysKeys && step.fields[i].id === 'weight') {
                                                let dailyWeightDaysSum = 0
                                                let dailyWeightDaysLength = 0
                                                step.fields.forEach(function (fd) {
                                                    if (dailyWeightDaysKeys.indexOf(fd.id) > -1 && fd.value) {
                                                        dailyWeightDaysSum += fd.value
                                                        dailyWeightDaysLength += 1
                                                    }
                                                })
                                                if (dailyWeightDaysSum > 0) {
                                                    step.fields[i].value = Math.round((dailyWeightDaysSum / dailyWeightDaysLength) * 10) / 10
                                                }
                                                step.fields[i].disabled = true
                                            }
                                            if (step.fields[i].type === 'datepicker_inline' && step.fields[i].value) {
                                                const valueSplit = step.fields[i].value.split('-')
                                                if (valueSplit.length === 3) {
                                                    self.datepickerInline = {
                                                        year: valueSplit[0],
                                                        month: valueSplit[1],
                                                        day: valueSplit[2],
                                                    }
                                                }
                                            }
                                            if (step.fields[i].id === 'date' && !step.fields[i].value && data && data.date) {
                                                step.fields[i].value = data.date
                                            }
                                            if (step.fields[i].filterKey === 'cardio' && cardioData) {
                                                const cardioDataItem = cardioData.find((cardioItem) => {
                                                    return cardioItem.id === step.fields[i].id
                                                })
                                                if (cardioDataItem) {
                                                    step.fields[i].value = cardioDataItem.value
                                                }
                                            }
                                            self.$set(step.fields, i, step.fields[i])
                                        }
                                    }
                                }

                                if (step.json_keys && step.fields) {
                                    for (let i = 0; i < step.fields.length; i++) {
                                        if (step.fields[i].save) {
                                            const stepId = step.fields[i].replaceId ? step.fields[i].replaceId : step.fields[i].id
                                            if (step.fields[i].isRemarks) {
                                                step.fields[i].value = data.remarks
                                            } else if (step.fields[i].parentId) {
                                                step.fields[i].value = data[step.fields[i].parentId][stepId] ? data[step.fields[i].parentId][stepId] : ''
                                            }  else if (step.fields[i].updateUser && (userData[step.fields[i].updateUser] || userData[step.fields[i].updateUser] === 0)) {
                                                step.fields[i].value = userData[step.fields[i].updateUser]
                                            } else {
                                                step.fields[i].value = data[step.id][stepId] ? data[step.id][stepId] : ''
                                            }
                                            self.$set(step.fields, i, step.fields[i])
                                        }
                                    }
                                }
                            }

                            Api.getPhysicalEvaluationPhotos({
                                client_id: self.user.db_id,
                                id: data.id
                            }, function (response) {
                                if (response.success && response.data && response.data.length) {
                                    self.physicalEvaluationToSave.photosIds = response.data.map(value => value.id)
                                    const keys = ['photos', 'videos']
                                    for (let s = 0; s < self.config.steps.length; s++) {
                                        const step = self.config.steps[s]
                                        if (keys.indexOf(step.id) > -1) {
                                            self.requestsDone.uploadedPhotos = []
                                            response.data.forEach(function (it, index) {
                                                step.photos[index] = it.photo
                                                self.$set(step.photos, index, it.photo)
                                                self.requestsDone.uploadedPhotos.push(it.photo)
                                            })
                                        }
                                    }
                                }
                                self.getDataCallbackReady(true, true)
                            })
                        }
                    } catch (error) { }
                }
            },
            refreshPage: function () {
                const self = this
                window.scrollTo(0, 0)
                Utils.refreshStyles(this.config, function () {
                    self.initialized = true
                    if (self.openedSteps.indexOf(self.config.steps[self.stepIndex].id) === -1) {
                        self.openedSteps.push(self.config.steps[self.stepIndex].id)
                    }
                })
            },
            refreshForms: function () {
                const self = this
                let randomQuestionsAdded = []
                const proofStepIndex = this.config.steps.findIndex(step => step.id === 'proof')
                if (proofStepIndex > -1 && this.user && this.user.paym_sub) {
                    this.config.steps.splice(proofStepIndex, 1)
                }
                for (let i = 0; i < this.config.steps.length; i++) {
                    if (this.config.steps[i].fields) {
                        randomQuestionsAdded = []
                        for (let f = 0; f < this.config.steps[i].fields.length; f++) {
                            if (this.config.steps[i].fields[f].dashboard && window.openedByDashboard) {
                                delete this.config.steps[i].fields[f].hidden
                            }
                            if (window.openedByDashboard && this.config.steps[i].fields[f].required) {
                                this.config.steps[i].fields[f].required = false
                                delete this.config.steps[i].fields[f].showRequiredCharacter
                            }
                            if (this.config.steps[i].fields[f].id === 'height' && this.config.steps[i].fields[f].autoFill) {
                                this.setHeightValue()
                            }
                            if (this.config.steps[i].fields[f].type === 'select' ||
                                this.config.steps[i].fields[f].type === 'select_search' ||
                                this.config.steps[i].fields[f].type === 'select_search_dialog' ||
                                this.config.steps[i].fields[f].type === 'tags' ||
                                this.config.steps[i].fields[f].type === 'buttons' ||
                                this.config.steps[i].fields[f].type === 'multiselect' ||
                                this.config.steps[i].fields[f].type === 'multiselect_search' ||
                                this.config.steps[i].fields[f].type === 'scale'
                            ) {
                                if (this.config.steps[i].fields[f].type === 'tags') {
                                    this.config.steps[i].fields[f].value = []
                                }
                                if (this.config.steps[i].fields[f].id === 'gender') {
                                    this.config.steps[i].fields[f].items = Utils.getGenders()
                                }
                                if (this.config.steps[i].fields[f].id === 'physical_condition') {
                                    this.config.steps[i].fields[f].items = Utils.getPhysicalConditions()
                                }
                                if (this.config.steps[i].fields[f].id === 'goal') {
                                    this.config.steps[i].fields[f].items = Utils.getGoals()
                                }
                                if (this.config.steps[i].fields[f].id === 'feedback_rating' && !this.config.steps[i].fields[f].items.length) {
                                    this.config.steps[i].fields[f].items = Utils.getFeedbackRating()
                                }
                                if (this.config.steps[i].fields[f].enumsKey && Utils[this.config.steps[i].fields[f].enumsKey]) {
                                    this.config.steps[i].fields[f].items = Utils[this.config.steps[i].fields[f].enumsKey]()
                                }
                                if (this.config.steps[i].fields[f].saveLabel && this.config.steps[i].fields[f].items) {
                                    this.config.steps[i].fields[f].items.forEach(function (it) {
                                        it.value = it.label
                                    })
                                }
                                if (this.config.steps[i].fields[f].request && !this.config.steps[i].fields[f].request.cache) {
                                    Api.getRequest({
                                        url: this.config.steps[i].fields[f].request.url,
                                        item: this.config.steps[i].fields[f]
                                    }, function (response) {
                                        let requestItems = []
                                        if (response.success) {
                                            const responseData = response.data && response.data.data ? response.data.data : response.data
                                            const requestItem = response.item
                                            let requestKey = null
                                            let onlyUseKeyName = false

                                            if (requestItem.request.key) {
                                                if (requestItem.request.key === 'countries') {
                                                    requestKey = self.getCountryNameKey()
                                                } else {
                                                    requestKey = requestItem.request.key
                                                }
                                            }
                                            if (requestItem.request.key_name) {
                                                requestKey = requestItem.request.key_name
                                                onlyUseKeyName = true
                                            }

                                            for (let i = 0; i < responseData.length; i++) {
                                                let keyValue = responseData[i]
                                                if (requestKey) {
                                                    switch (requestKey.length) {
                                                        case 1:
                                                            if (requestKey[0].indexOf('<lng>') > -1) {
                                                                const requestKeyLng = requestKey[0].replace('<lng>', window.language)
                                                                if (responseData[i][requestKeyLng]) {
                                                                    keyValue = responseData[i][requestKeyLng]
                                                                } else {
                                                                    keyValue = responseData[i][requestKey[0].replace('_<lng>', '')]
                                                                }
                                                            } else {
                                                                keyValue = responseData[i][requestKey[0]]
                                                            }
                                                            break
                                                        case 2:
                                                            keyValue = responseData[i][requestKey[0]][requestKey[1]]
                                                            break
                                                        case 3:
                                                            keyValue = responseData[i][requestKey[0]][requestKey[1]][requestKey[2]]
                                                            break
                                                    }
                                                }

                                                const obj = {
                                                    label: requestKey ? keyValue : Utils.capitalize(responseData[i].name),
                                                    value: requestKey && !onlyUseKeyName ? keyValue : responseData[i].id
                                                }
                                                requestItems.push(obj)

                                                if (requestItem.request.filter) {
                                                    if (!requestItem.request.filter.values) {
                                                        requestItem.request.filter.values = {}
                                                    }
                                                    if (responseData[i][requestItem.request.filter.fieldToUse]) {
                                                        requestItem.request.filter.values[obj.value] = responseData[i][requestItem.request.filter.fieldToUse].split(', ')
                                                    }
                                                }
                                            }

                                            requestItems = requestItems.sort((a, b) => a.label.localeCompare(b.label))

                                            if (requestItem.request.filter && requestItem.request.filter.values) {
                                                self.config.steps.forEach(function (st) {
                                                    if (st.fields) {
                                                        st.fields.forEach(function (fd) {
                                                            if (fd.request && fd.request.cache && fd.request.filter && fd.request.url === requestItem.request.url) {
                                                                fd.request.filter.values = requestItem.request.filter.values
                                                            }
                                                        })
                                                    }
                                                })
                                            }
                                        }

                                        response.item.items = requestItems
                                        self.setRequestCache(response.item)
                                        self.applyFieldsValuesConversions()
                                        self.getDataCallbackReady(true)
                                    })
                                }
                            }

                            if (this.config.steps[i].randomQuestions && !this.config.steps[i].fields[f].title) {
                                const randomQuestions = this.getRandomQuestions(this.config.steps[i].randomQuestions, this.config.steps[i].fields[f].id, randomQuestionsAdded)
                                const randomQuestionIndex = Math.floor(Math.random() * randomQuestions.length)
                                randomQuestionsAdded.push(randomQuestions[randomQuestionIndex].text)
                                this.config.steps[i].fields[f].title = randomQuestions[randomQuestionIndex].text
                                this.config.steps[i].fields[f].titleTranslationId = randomQuestions[randomQuestionIndex].textTranslationId
                                randomQuestions.splice(randomQuestionIndex, 1)
                            }

                            if (this.config.steps[i].fields[f].useWorkoutsFlags) {
                                this.getWorkoutsFlags()
                            }
                        }
                    }

                    if (window.openedByDashboard && this.config.steps[i].requiredPhotos) {
                        this.config.steps[i].requiredPhotos = null
                    }

                    if (this.config.steps[i].video) {
                        this.config.steps[i].video = Utils.getYoutubeEmbedUrl(this.config.steps[i].video)
                    }
                }
            },
            setHeightValue: function () {
                try {
                    Api.getLastPhysicalEvaluation({
                        client_id: this.user.db_id
                    }, (response) => {
                        if (response && response.success && response.data && response.data[0] && response.data[0].body && response.data[0].body.height) {
                            for (let i = 0; i < this.config.steps.length; i++) {
                                if (this.config.steps[i].fields) {
                                    for (let f = 0; f < this.config.steps[i].fields.length; f++) {
                                        if (this.config.steps[i].fields[f].id === 'height') {
                                            this.config.steps[i].fields[f].value = response.data[0].body.height
                                            return true
                                        }
                                    }
                                }
                            }
                        }
                    })
                } catch {}
            },
            getCountryNameKey: function () {
                if (window.language === 'en') {
                    return ['name', 'common']
                }
                if (window.language === 'es') {
                    return ['translations', 'spa', 'common']
                }
                if (window.language === 'fr') {
                    return ['translations', 'fra', 'common']
                }
                if (window.language === 'de') {
                    return ['translations', 'deu', 'common']
                }
                return ['translations', 'por', 'common']
            },
            getRandomQuestions: function (randomQuestions, id, questionsToExclude) {
                const self = this
                let questions = JSON.parse(JSON.stringify(randomQuestions))
                questions = questions.filter(function (item) {
                    if (item.fixed && item.fixed !== id) {
                        return false
                    }
                    if (questionsToExclude && questionsToExclude.length && questionsToExclude.indexOf(item.text) > -1) {
                        return false
                    }
                    let conditionResult = true
                    if (item.conditions) {
                        item.conditions.forEach(function (cd) {
                            if (cd && ((cd.include && !self.user[cd.field].includes(cd.value)) || (!cd.include && self.user[cd.field] !== cd.value))) {
                                conditionResult = false
                                return false
                            }
                        })
                    }
                    return conditionResult
                })
                const fixedQuestions = questions.filter(function (item) {
                    if (item.fixed && item.fixed === id) {
                        return true
                    }
                    return false
                })
                if (fixedQuestions.length) {
                    questions = fixedQuestions
                }
                const priorityQuestions = questions.filter(function (item) {
                    if (item.priority) {
                        return true
                    }
                    return false
                })
                if (priorityQuestions.length) {
                    const highPriorityQuestions = priorityQuestions.filter(function (item) {
                        if (item.priority === 1) {
                            return true
                        }
                        return false
                    })
                    if (highPriorityQuestions.length) {
                        questions = highPriorityQuestions
                    } else {
                        questions = priorityQuestions
                    }
                }
                return questions
            },
            setRequestCache: function (item) {
                if (item.request) {
                    for (let i = 0; i < this.config.steps.length; i++) {
                        if (this.config.steps[i].fields) {
                            for (let f = 0; f < this.config.steps[i].fields.length; f++) {
                                const field = this.config.steps[i].fields[f]
                                if (field.request && field.request.cache && field.request.url === item.request.url) {
                                    field.items = JSON.parse(JSON.stringify(item.items))
                                }
                            }
                        }
                    }
                }
            },
            applyFieldsValuesConversions: function () {
                for (let i = 0; i < this.config.steps.length; i++) {
                    if (this.config.steps[i].fields) {
                        for (let f = 0; f < this.config.steps[i].fields.length; f++) {
                            const field = this.config.steps[i].fields[f]
                            if (field.needToConvertToId) {
                                if (!field.items || (field.items && !field.items.length)) {
                                    continue
                                }
                                let newValue = ''
                                if (typeof field.value === 'string') {
                                    newValue = field.value
                                    const itemFound = field.items.find(function (item) {
                                        return item.label === field.value || item.value === field.value
                                    })
                                    if (itemFound) {
                                        newValue = itemFound.value
                                    }
                                } else {
                                    newValue = []
                                    field.value.forEach(function (value) {
                                        const itemFound = field.items.find(function (item) {
                                            return item.label === value || item.value === value
                                        })
                                        if (itemFound) {
                                            newValue.push(itemFound.value)
                                        }
                                    })
                                }
                                field.value = newValue
                                delete field.needToConvertToId
                            }
                        }
                    }
                }
            },
            getWorkoutsFlags: function () {
                const self = this
                if (!this.workoutsFlagsRequest) {
                    this.workoutsFlagsRequest = true
                    Api.getWorkouts(function (response) {
                        if (response.success) {
                            const workoutsFlags = {}
                            const items = Utils.getWorkoutFlags()
                            response.data.forEach(function (w) {
                                if (w.flags) {
                                    items.forEach(function (item) {
                                        if (w.flags & item.value) {
                                            if (!workoutsFlags[item.id]) {
                                                workoutsFlags[item.id] = {
                                                    answer: item.answer,
                                                    field: item.field,
                                                    condition: item.condition,
                                                    data: []
                                                }
                                            }
                                            workoutsFlags[item.id].data.push(w.id) 
                                        }
                                    })
                                }
                            })
                            self.workoutsFlags = workoutsFlags
                        }
                    })
                }
            },
            checkItemCondition: function (step, item) {
                if (step && step.fields && item && item.valueCondition) {
                    let parentField = step.fields.find(function (elem) {
                        return elem.parentCondition === item.id ||
                            (typeof elem.parentCondition === 'object' &&
                                elem.parentCondition.indexOf(item.id) > -1)
                    })
                    if (!parentField) {
                        try {
                            for (let i = 0; i < this.config.steps.length; i++) {
                                if (this.config.steps[i].fields) {
                                    for (let f = 0; f < this.config.steps[i].fields.length; f++) {
                                        const field = this.config.steps[i].fields[f]
                                        if (field.parentCondition === item.id ||
                                            (typeof field.parentCondition === 'object' &&
                                                field.parentCondition.indexOf(item.id) > -1)) {
                                                    parentField = field
                                            break
                                        }
                                    }
                                }
                                if (parentField) {
                                    break
                                }
                            }
                        } catch { }
                    }
                    if (parentField) {
                        const isValueConditionArray = Array.isArray(item.valueCondition)
                        const isParentValueArray = Array.isArray(parentField.value)
                        let conditionMet = false
                        if (isValueConditionArray && isParentValueArray) {
                            conditionMet = item.valueCondition.some(val => parentField.value.includes(val))
                        } else if (isValueConditionArray) {
                            conditionMet = item.valueCondition.includes(parentField.value)
                        } else if (isParentValueArray) {
                            conditionMet = parentField.value.includes(item.valueCondition)
                        } else {
                            conditionMet = parentField.value === item.valueCondition
                        }
                        if (!conditionMet) {
                            item.value = ''
                            return false
                        }
                    }
                }
                if (item && item.parentConditionStep) {
                    for (let i = 0; i < this.config.steps.length; i++) {
                        if (this.config.steps[i].stepCondition && this.config.steps[i].stepCondition.id === item.parentConditionStep) {
                            this.config.steps[i].hidden = this.config.steps[i].stepCondition.value !== item.value ? true : false
                            break
                        }
                    }
                }
                if (step.hidden) {
                    return false
                }
                if (item.hidden) {
                    return false
                }
                if (item.onlyShowDashboard) {
                    return false
                }
                if (item.onlyShowView) {
                    return false
                }
                if (step.sendAudioOrText && ((step.sendAudioOrText.value && item.type !== 'audio') || (!step.sendAudioOrText.value && item.type === 'audio'))) {
                    item.value = ''
                    return false
                }
                if (this.userPack && item.pack_form_ids && !item.pack_form_ids.includes(this.userPack.form)) {
                    return false
                }
                return true
            },
            changeDatepicker: function (item, date) {
                for (let i = 0; i < this.config.steps[this.stepIndex].fields.length; i++) {
                    if (this.config.steps[this.stepIndex].fields[i].id === item.id) {
                        this.config.steps[this.stepIndex].fields[i].value = date ? moment(date).format('YYYY-MM-DD') : date
                        this.datepicker[item.id] = false
                        break
                    }
                }
            },
            changeTimepicker: function (date, item) {
                item.value = date
                this.timepicker[item.id] = false
            },
            onChangeSelect: function (item) {
                const self = this
                if (item && item.value && item.triggerValue) {
                    this.handleTriggerValue(item)
                }
                if (item && item.value && item.triggerValues) {
                    item.triggerValues.forEach(function (value) {
                        self.handleTriggerValue({
                            triggerValue: value,
                            value: item.value
                        })
                    })
                }
            },
            handleTriggerValue: function (item) {
                const self = this
                let value = ''
                if (item.triggerValue.id === 'mobile_phone' && !item.triggerValue.value) {
                    value = this.mobilePhonePrefixs[item.value] ? this.mobilePhonePrefixs[item.value] : ''
                } else {
                    if (item.triggerValue.values) {
                        const valueActive = item.triggerValue.values.find(function (vl) {
                            return vl.value === item.value
                        })
                        if (valueActive) {
                            const currentStep = self.config.steps[self.stepIndex]
                            const field = currentStep.fields.find(function (it) {
                                return it.id === item.triggerValue.id
                            })
                            if (field) {
                                if (field.type === 'select' ||
                                    field.type === 'select_search' ||
                                    field.type === 'select_search_dialog' ||
                                    field.type === 'multiselect' ||
                                    field.type === 'multiselect_search'
                                ) {
                                    field.value = field.value ? field.value : []
                                    if (valueActive.addValue) {
                                        valueActive.addValue.forEach(function (vl) {
                                            if (field.value.indexOf(vl) === -1) {
                                                field.value.push(vl)
                                            }
                                        })
                                    }
                                    if (valueActive.removeValue) {
                                        valueActive.removeValue.forEach(function (vl) {
                                            const index = field.value.indexOf(vl)
                                            if (index > -1) {
                                                field.value.splice(index, 1)
                                            }
                                        })
                                    }
                                } else {
                                    field.value = valueActive
                                }
                            }
                        }
                        return true
                    } else {
                        value = item.triggerValue.value
                    }
                }
                if (value) {
                    setTimeout(function () {
                        const currentStep = self.config.steps[self.stepIndex]
                        const field = currentStep.fields.find(function (it) {
                            return it.id === item.triggerValue.id
                        })
                        if (field && field.value.indexOf(value) === -1) {
                            field.value = value
                        }
                    })
                }
            },
            receivePhoto: function (photoBase64, index) {
                const currentStep = this.config.steps[this.stepIndex]
                this.$set(currentStep.photos, index, photoBase64)
            },
            receiveVideo: function (videoId, args) {
                if (args.item) {
                    args.item.value = videoId
                } else {
                    const index = args
                    const currentStep = this.config.steps[this.stepIndex]
                    this.$set(currentStep.videos, index, videoId)
                }
            },
            openStep: function (index) {
                if (this.stepIndex !== index) {
                    this.initialized = false
                    this.stepIndex = index
                    this.refreshPage()
                }
            },
            goToPreviousStep: function () {
                this.initialized = false
                if (this.stepIndex > 0) {
                    this.stepIndex -= 1
                } else {
                    this.stepIndex = this.config.steps.length - 1
                }
                this.refreshPage()
            },
            goToNextStep: function () {
                this.initialized = false
                if (this.stepIndex < this.config.steps.length - 1) {
                    this.stepIndex += 1
                } else {
                    this.stepIndex = 0
                }
                this.refreshPage()
            },
            backStep: function () {
                if (this.stepIndex > 0) {
                    const currentStep = this.config.steps[this.stepIndex]
                    this.initialized = false

                    if (currentStep.backStep) {
                        const backStepIndex = this.config.steps.findIndex(function (item) {
                            return item.id === currentStep.backStep
                        })
                        this.stepIndex = backStepIndex
                    } else {
                        this.stepIndex -= 1
                    }

                    this.refreshPage()
                } else {
                    this.closeView()
                }
            },
            nextStep: function (nextStepId, hideStep) {
                const self = this
                const currentStep = this.config.steps[this.stepIndex]

                if (currentStep.id === 'photos') {
                    let photosValidated = true

                    if (currentStep.requiredPhotos) {
                        let counter = 0
                        for (let i = 0; i < currentStep.photos.length; i++) {
                            if (currentStep.photos[i]) {
                                counter += 1
                            }
                        }

                        if (counter < currentStep.requiredPhotos) {
                            photosValidated = false
                        }
                    }

                    if (photosValidated) {
                        newStep()
                    } else {
                        this.$alert(
                            currentStep.failedMessage,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }

                    return true
                }

                if (currentStep.id === 'videos') {
                    let videosValidated = true

                    if (currentStep.requiredVideos) {
                        let counter = 0
                        for (let i = 0; i < currentStep.videos.length; i++) {
                            if (currentStep.videos[i] === 'processing') {
                                videosValidated = false
                                return this.$alert(
                                    window.strings['processing'],
                                    '',
                                    'warning',
                                    Utils.getAlertOptions()
                                )
                            }
                            if (currentStep.videos[i]) {
                                counter += 1
                            }
                        }

                        if (counter < currentStep.requiredVideos) {
                            videosValidated = false
                        }
                    }

                    if (videosValidated) {
                        newStep()
                    } else {
                        this.$alert(
                            currentStep.failedMessage,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }

                    return true
                }

                if (currentStep.goToStep && nextStepId) {
                    const newStepIndexFound = this.config.steps.findIndex(function (st) {
                        return st.id === nextStepId
                    })
                    if (this.config.steps[newStepIndexFound] && this.config.steps[newStepIndexFound].hidden) {
                        delete this.config.steps[newStepIndexFound].hidden
                    }
                    if (hideStep) {
                        const hideStepIndexFound = this.config.steps.findIndex(function (st) {
                            return st.id === hideStep
                        })
                        if (hideStepIndexFound > -1) {
                            this.config.steps[hideStepIndexFound].hidden = true
                        }
                    }
                    newStep(newStepIndexFound)
                    return true
                }

                if (validateGoToStepId()) {
                    return true
                }

                newStep()

                function validateGoToStepId() {
                    if (currentStep.goToStepId) {
                        const newStepIndexFound = self.config.steps.findIndex(function (st) {
                            return st.id === currentStep.goToStepId
                        })
                        newStep(newStepIndexFound)
                        return true
                    }
                    return false
                }

                function newStep(newStepIndex) {
                    if (currentStep.fields && !self.validateFields(currentStep)) {
                        return false
                    }
                    self.initialized = false
                    if (newStepIndex) {
                        self.stepIndex = newStepIndex
                    } else {
                        self.stepIndex += 1
                    }
                    self.checkStepCondition()
                    self.checkSaveNext()
                    self.refreshPage()
                }
            },
            checkStepCondition: function () {
                try {
                    const currentStep = this.config.steps[this.stepIndex]
                    if (currentStep.stepCondition && currentStep.hidden) {
                        this.stepIndex += 1
                    }
                } catch { }
            },
            validateFields: function (step) {
                let valid = true
                let fieldsValue = {}
                for (let i = 0; i < step.fields.length; i++) {
                    const field = step.fields[i]
                    fieldsValue[field.id] = field.value
                    if (field.required &&
                        !checkValue(field) &&
                        this.checkItemCondition(step, field)
                    ) {
                        valid = false
                    }
                    if (!checkGreaterThanZero(field)) {
                        valid = false
                    }
                    if (field.rejectValues && field.rejectValues.indexOf(field.value) > -1) {
                        valid = false
                    }
                    if (field.sameValue && fieldsValue[field.sameValue] !== field.value) {
                        this.$alert(
                            field.failedMessage,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                        return false
                    }
                    if (field.dateMaskInvalid && this.checkItemCondition(step, field)) {
                        this.$alert(
                            window.strings['invalid_date'],
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                        return false
                    }
                    if (field.type === 'video' && field.value === 'processing') {
                        this.$alert(
                            window.strings['processing'],
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                        return false
                    }
                }
                if (valid) {
                    return true
                } else {
                    this.$alert(
                        step.emptyFailedMessage,
                        '',
                        'warning',
                        Utils.getAlertOptions()
                    )
                    return false
                }

                function checkValue(fd) {
                    const valueStr = fd.value !== null ? fd.value.toString() : ''
                    if ((fd.biggerThen || fd.biggerThen === 0) && parseFloat(fd.value) <= fd.biggerThen) {
                        return false
                    }
                    if (valueStr.replace(/\s/g, '').length) {
                        return true
                    } else {
                        return false
                    }
                }

                function checkGreaterThanZero(item) {
                    if (item && item.greaterThanZero && item.value && parseFloat(item.value) < 1) {
                        return false
                    }
                    return true
                }
            },
            validateCheckbox: function (step) {
                if (step && step.checkbox && step.checkbox.required && !step.checkbox.value) {
                    this.$alert(
                        window.strings[step.checkbox.required]
                            ? window.strings[step.checkbox.required]
                            : step.checkbox.required,
                        '',
                        'warning',
                        Utils.getAlertOptions(),
                    )
                    return false
                }
                return true
            },
            checkSaveNext: function () {
                if (this.config.saveNext) {
                    delete this.requestsDone.newPhysicalEvaluation
                    delete this.requestsDone.updateUser
                    this.save(true, true)
                }
            },
            save: function (sendLater, saveNext) {
                this.clearRequestFlags()
                const isSaveNext = saveNext ? true : false
                this.statusToSave = sendLater ? this.status.sendLater : (window.initialQuiz ? this.status.initialQuiz : this.status.sendNow)

                if (window.openedByDashboard && !sendLater) {
                    this.statusToSave = this.status.validated
                }

                if (this.config.saveStatus && !sendLater) {
                    this.statusToSave = this.config.saveStatus
                }

                if (sendLater) {
                    for (let i = 0; i < this.config.steps.length; i++) {
                        const step = this.config.steps[i]

                        if (step.id === 'videos') {
                            for (let i = 0; i < step.videos.length; i++) {
                                if (step.videos[i] === 'processing') {
                                    return this.$alert(
                                        window.strings['processing'],
                                        '',
                                        'warning',
                                        Utils.getAlertOptions()
                                    )
                                }
                            }
                        }

                        if (step.fields) {
                            for (let f = 0; f < step.fields.length; f++) {
                                const field = step.fields[f]
                                if (field.type === 'video' && field.value === 'processing') {
                                    return this.$alert(
                                        window.strings['processing'],
                                        '',
                                        'warning',
                                        Utils.getAlertOptions()
                                    )
                                }
                                if (field.dateMaskInvalid && this.checkItemCondition(step, field)) {
                                    return this.$alert(
                                        window.strings['invalid_date'],
                                        '',
                                        'warning',
                                        Utils.getAlertOptions()
                                    )
                                }
                            }
                        }
                    }
                } else {
                    for (let i = 0; i < this.config.steps.length; i++) {
                        const step = this.config.steps[i]

                        if (step.id === 'photos' || step.id === 'proof') {
                            let photosValidated = true

                            if (step.requiredPhotos) {
                                let counter = 0
                                for (let i = 0; i < step.photos.length; i++) {
                                    if (step.photos[i]) {
                                        counter += 1
                                    }
                                }

                                if (counter < step.requiredPhotos) {
                                    photosValidated = false
                                }
                            }

                            if (!photosValidated) {
                                return this.$alert(
                                    step.failedMessage,
                                    '',
                                    'warning',
                                    Utils.getAlertOptions()
                                )
                            }
                        }

                        if (step.id === 'videos') {
                            let videosValidated = true

                            if (step.requiredVideos) {
                                let counter = 0
                                for (let i = 0; i < step.videos.length; i++) {
                                    if (step.videos[i] === 'processing') {
                                        videosValidated = false
                                        return this.$alert(
                                            window.strings['processing'],
                                            '',
                                            'warning',
                                            Utils.getAlertOptions()
                                        )
                                    }
                                    if (step.videos[i]) {
                                        counter += 1
                                    }
                                }

                                if (counter < step.requiredVideos) {
                                    videosValidated = false
                                }
                            }

                            if (!videosValidated) {
                                return this.$alert(
                                    step.failedMessage,
                                    '',
                                    'warning',
                                    Utils.getAlertOptions()
                                )
                            }
                        }

                        if (step.fields) {
                            if (!this.validateFields(step)) {
                                return false
                            }
                        }

                        if (!this.validateCheckbox(step)) {
                            return false
                        }
                    }
                }

                this.newPhysicalEvaluation(isSaveNext)
            },
            clearRequestFlags: function () {
                if (this.config.saveNext) {
                    this.processing = false
                    delete this.requestsDone.newPhysicalEvaluation
                    delete this.requestsDone.updateUser
                }
            },
            newPhysicalEvaluation: function (isSaveNext, onlyGetData) {
                const self = this

                if (!self.validateRequiredSteps() && !onlyGetData) {
                    return false
                }

                if (!self.processing || onlyGetData) {
                    self.processing = true
                    if (!isSaveNext) {
                        self.$isLoading(true)
                    }

                    let data = {}

                    if (window.physicalEvaluationToEdit) {
                        data = {
                            client_id: self.user.db_id,
                        }
                    } else {
                        data = {
                            date: moment.utc().format('YYYY-MM-DD'),
                            date_time: moment.utc().format('HH:mm'),
                            date_next: self.user.feedback_day,
                            client_id: self.user.db_id,
                            status: self.statusToSave
                        }
                    }

                    const dailyWeightDaysKeys = self.config.saveDailyWeight ? Utils.getDailyWeightDays().map(dw => dw.value) : null
                    let userDataToUpdate = null

                    if (self.physicalEvaluationToSave) {
                        data.id = self.physicalEvaluationToSave.id
                    }

                    if (window.configType) {
                        const typeValue = parseInt(window.configType)
                        if (!isNaN(typeValue)) {
                            data.type = typeValue
                        }
                    }

                    for (let s = 0; s < self.config.steps.length; s++) {
                        const step = self.config.steps[s]
                        const keyId = step.replaceId ? step.replaceId : step.id

                        if (step.json_string && step.fields && !step.hidden) {
                            if (!step.json_increment || !data[keyId]) {
                                data[keyId] = [];
                            }

                            for (let i = 0; i < step.fields.length; i++) {
                                if (step.fields[i].save && self.checkItemCondition(step, step.fields[i])) {
                                    const stepId = step.fields[i].replaceId ? step.fields[i].replaceId : step.fields[i].id
                                    let value = step.fields[i].value
                                    if (dailyWeightDaysKeys && step.fields[i].id === 'weight') {
                                        let dailyWeightDaysSum = 0
                                        let dailyWeightDaysLength = 0
                                        step.fields.forEach(function (fd) {
                                            if (dailyWeightDaysKeys.indexOf(fd.id) > -1 && fd.value) {
                                                dailyWeightDaysSum += parseFloat(fd.value)
                                                dailyWeightDaysLength += 1
                                            }
                                        })
                                        if (dailyWeightDaysSum > 0) {
                                            value = Math.round((dailyWeightDaysSum / dailyWeightDaysLength) * 10) / 10
                                        }
                                    }
                                    if (value && step.fields[i].inputType === 'numeric') {
                                        value = parseFloat(typeof value === 'string' ? value.replace(/,/g, '.') : value)
                                    }
                                    if (value && step.fields[i].inputType === 'integer') {
                                        value = value.toString()
                                        value = value.replace(/,/g, '').replace(/\./g, '')
                                        value = parseInt(value)
                                    }
                                    if (step.fields[i].inputType == 'email') {
                                        value = Utils.encodeEmail(value)
                                    }
                                    if (step.fields[i].parentId) {
                                        if (!data[step.fields[i].parentId]) {
                                            data[step.fields[i].parentId] = {}
                                        }
                                        data[step.fields[i].parentId][stepId] = value
                                    } else if (step.fields[i].updateUser) {
                                        if (!userDataToUpdate) {
                                            userDataToUpdate = {}
                                        }
                                        if (step.fields[i].saveJsonId) {
                                            if (!userDataToUpdate[step.fields[i].updateUser]) {
                                                userDataToUpdate[step.fields[i].updateUser] = {}
                                            }
                                            if (step.fields[i].type == 'multiselect' || step.fields[i].type == 'multiselect_search') {
                                                if (!userDataToUpdate[step.fields[i].updateUser][step.fields[i].saveJsonId]) {
                                                    userDataToUpdate[step.fields[i].updateUser][step.fields[i].saveJsonId] = []
                                                }
                                                if (value) {
                                                    value.forEach(function (vl) {
                                                        if (userDataToUpdate[step.fields[i].updateUser][step.fields[i].saveJsonId].indexOf(vl) === -1) {
                                                            userDataToUpdate[step.fields[i].updateUser][step.fields[i].saveJsonId].push(vl)
                                                        }
                                                    })
                                                }
                                            } else {
                                                let parentValue = null
                                                if (step.fields[i].saveParentValue) {
                                                    const parentField = step.fields.find(pf => pf.id === step.fields[i].saveParentValue)
                                                    if (parentField) {
                                                        parentValue = parentField.value
                                                    }
                                                }
                                                userDataToUpdate[step.fields[i].updateUser][step.fields[i].saveJsonId] = (parentValue ? (parentValue + ' - ') : '') + value
                                            }
                                        } else {
                                            if ((step.fields[i].type == 'multiselect' || step.fields[i].type == 'multiselect_search') && value) {
                                                userDataToUpdate[step.fields[i].updateUser] = value.join(', ')
                                            } else {
                                                userDataToUpdate[step.fields[i].updateUser] = value
                                            }
                                        }
                                        if (step.fields[i].saveQuestion) {
                                            if (step.fields[i].useLabelValueQuestion && value) {
                                                if (step.fields[i].type == 'multiselect' || step.fields[i].type == 'multiselect_search') {
                                                    const newValueWithLabels = []
                                                    value.forEach(function (vl) {
                                                        const vlItem = step.fields[i].items.find(function (fIt) {
                                                            return fIt.value === vl
                                                        })
                                                        if (vlItem) {
                                                            newValueWithLabels.push(vlItem.label)
                                                        } else {
                                                            newValueWithLabels.push(vl)
                                                        }
                                                    })
                                                    value = newValueWithLabels
                                                } else {
                                                    const vlItem = step.fields[i].items.find(function (fIt) {
                                                        return fIt.value === value
                                                    })
                                                    value = vlItem ? vlItem.label : value
                                                }
                                            }
                                            if ((step.fields[i].type == 'multiselect' || step.fields[i].type == 'multiselect_search') && typeof value === 'object') {
                                                value = value.join(', ')
                                            }
                                            data[keyId].push({
                                                id: stepId,
                                                parent: step.fields[i].parent,
                                                title: self.config.useTranslationId ? step.fields[i].titleTranslationId : step.fields[i].title,
                                                value: value,
                                                answer: value,
                                            })
                                        }
                                    } else if (step.fields[i].useField) {
                                        data[stepId] = value
                                    } else {
                                        if ((step.fields[i].type == 'multiselect' || step.fields[i].type == 'multiselect_search') && typeof value === 'object') {
                                            value = value.join(', ')
                                        }
                                        const payloadToSave = {
                                            id: stepId,
                                            parent: step.fields[i].parent,
                                            title: self.config.useTranslationId ? step.fields[i].titleTranslationId : step.fields[i].title,
                                            value: value,
                                            answer: value,
                                        }
                                        if (step.fields[i].saveEmployee && self.userEmployees) {
                                            const employeeToSave = self.userEmployees.find(function (ue) {
                                                return ue[step.fields[i].saveEmployee.id] === step.fields[i].saveEmployee.value
                                            })
                                            if (employeeToSave) {
                                                payloadToSave.employee = employeeToSave.id
                                            }
                                        }
                                        data[keyId].push(payloadToSave)
                                    }
                                    if (step.fields[i].saveFieldId) {
                                        data[step.fields[i].saveFieldId] = value
                                    }
                                    const workoutsFlagsId = step.fields[i].saveJsonId ? step.fields[i].saveJsonId : step.fields[i].id
                                    if (step.fields[i].useWorkoutsFlags && self.workoutsFlags && self.workoutsFlags[workoutsFlagsId]) {
                                        let answer = self.workoutsFlags[workoutsFlagsId].answer
                                        if (self.workoutsFlags[workoutsFlagsId].condition) {
                                            answer = self.getWorkoutsFlagsConditionAnswer(workoutsFlagsId)
                                            answer = answer ? answer : []
                                        }
                                        let answerValueValid = false
                                        for (let w = 0; w < answer.length; w++) {
                                            if (answer[w].indexOf('>') > -1 || answer[w].indexOf('<') > -1) {
                                                const answerVal = parseInt(answer[w].match(/\d+/)[0], 10)
                                                if ((answer[w].indexOf('>') > -1 && value > answerVal) || (answer[w].indexOf('<') > -1 && value < answerVal)) {
                                                    answerValueValid = true
                                                }
                                            } else {
                                                if (answer.indexOf(value) > -1) {
                                                    answerValueValid = true
                                                }
                                            }
                                        }
                                        if (answerValueValid) {
                                            userDataToUpdate = userDataToUpdate ? userDataToUpdate : {}
                                            userDataToUpdate[step.fields[i].useWorkoutsFlags.field] = userDataToUpdate[step.fields[i].useWorkoutsFlags.field] ? userDataToUpdate[step.fields[i].useWorkoutsFlags.field] : {}
                                            userDataToUpdate[step.fields[i].useWorkoutsFlags.field][step.fields[i].useWorkoutsFlags.id] = userDataToUpdate[step.fields[i].useWorkoutsFlags.field][step.fields[i].useWorkoutsFlags.id] ? userDataToUpdate[step.fields[i].useWorkoutsFlags.field][step.fields[i].useWorkoutsFlags.id] : []
                                            self.workoutsFlags[workoutsFlagsId].data.forEach(function (wd) {
                                                if (userDataToUpdate[step.fields[i].useWorkoutsFlags.field][step.fields[i].useWorkoutsFlags.id].indexOf(wd) === -1) {
                                                    userDataToUpdate[step.fields[i].useWorkoutsFlags.field][step.fields[i].useWorkoutsFlags.id].push(wd)
                                                }
                                            })
                                        }
                                    }
                                }
                            }

                            if (!step.json_increment || step.json_last) {
                                data[keyId] = JSON.stringify(data[keyId])
                            }
                        }

                        if (step.json_keys && step.fields && !step.hidden) {
                            data[keyId] = {};

                            for (let i = 0; i < step.fields.length; i++) {
                                if (step.fields[i].save) {
                                    const stepId = step.fields[i].replaceId ? step.fields[i].replaceId : step.fields[i].id
                                    let value = step.fields[i].value
                                    if (value && step.fields[i].inputType === 'numeric') {
                                        value = parseFloat(typeof value === 'string' ? value.replace(/,/g, '.') : value)
                                    }
                                    if (value && step.fields[i].inputType === 'integer') {
                                        value = value.toString()
                                        value = value.replace(/,/g, '').replace(/\./g, '')
                                        value = parseInt(value)
                                    }
                                    if (step.fields[i].isRemarks) {
                                        data.remarks = value
                                    } else if (step.fields[i].parentId) {
                                        if (!data[step.fields[i].parentId]) {
                                            data[step.fields[i].parentId] = {}
                                        }
                                        data[step.fields[i].parentId][stepId] = value
                                    } else if (step.fields[i].updateUser) {
                                        if (!userDataToUpdate) {
                                            userDataToUpdate = {}
                                        }
                                        userDataToUpdate[step.fields[i].updateUser] = value
                                    } else if (step.fields[i].useField) {
                                        data[stepId] = value
                                    } else {
                                        data[keyId][stepId] = value
                                    }
                                }
                            }
                        }
                    }

                    if (self.config.userFieldsToUpdate) {
                        self.config.userFieldsToUpdate.forEach(function (userKey) {
                            let userSrc = {}
                            try {
                                if (self.user[userKey]) {
                                    userSrc = JSON.parse(self.user[userKey])
                                }
                            } catch (error) { }
                            for (const k in userDataToUpdate[userKey]) {
                                userSrc[k] = userDataToUpdate[userKey][k]
                            }
                            userDataToUpdate[userKey] = userSrc
                        })
                    }

                    if (self.config.userFieldsToString) {
                        self.config.userFieldsToString.forEach(function (userKey) {
                            if (userDataToUpdate && userDataToUpdate[userKey]) {
                                userDataToUpdate[userKey] = JSON.stringify(userDataToUpdate[userKey])
                            }
                        })
                    }

                    if (window.train || window.trainId || window.trainName || window.trainingPlanId) {
                        if (data.remarks) {
                            data.remarks = JSON.parse(data.remarks)
                        } else {
                            data.remarks = []
                        }
                        if (window.train) {
                            data.remarks.push({
                                id: 'train',
                                value: window.train
                            })
                        }
                        if (window.trainId) {
                            data.remarks.push({
                                id: 'train_id',
                                value: window.trainId
                            })
                        }
                        if (window.trainName) {
                            data.remarks.push({
                                id: 'train_name',
                                value: window.trainName
                            })
                        }
                        if (window.trainingPlanId) {
                            data.remarks.push({
                                id: 'training_plan_id',
                                value: window.trainingPlanId
                            })
                        }
                        data.remarks = JSON.stringify(data.remarks)
                    }

                    if (self.config.saveCardio && (!window.filterKey || window.filterKey === 'cardio')) {
                        const cardioData = []
                        for (const key in data.test) {
                            if (key.includes('cardio_')) {
                                cardioData.push({
                                    id: key,
                                    value: data.test[key]
                                })
                                delete data.test[key]
                            }
                        }
                        data.test.cardio = JSON.stringify(cardioData)
                    }

                    if (onlyGetData) {
                        return {
                            data: data,
                            userDataToUpdate: userDataToUpdate
                        }
                    }

                    self.handleRequest({
                        data: data,
                        userDataToUpdate: userDataToUpdate,
                        isSaveNext: isSaveNext
                    })
                }
            },
            getWorkoutsFlagsConditionAnswer: function (id) {
                if (this.workoutsFlags[id] && this.workoutsFlags[id].condition) {
                    for (let c = 0; c < this.workoutsFlags[id].condition.length; c++) {
                        const condition = this.workoutsFlags[id].condition[c];
                        for (let s = 0; s < this.config.steps.length; s++) {
                            const step = this.config.steps[s]
                            if (step.fields) {
                                const field = step.fields.find(function (f) {
                                    return f.id === condition.id
                                })
                                if (field && field.value === condition.value) {
                                    return condition.answer
                                }
                            }
                        }
                    }
                }
                return []
            },
            validateRequiredSteps: function () {
                if (this.config.required_steps) {
                    for (let i = 0; i < this.config.required_steps.steps.length; i++) {
                        if (this.openedSteps.indexOf(this.config.required_steps.steps[i]) === -1) {
                            this.$alert(
                                this.config.required_steps.message,
                                '',
                                'warning',
                                Utils.getAlertOptions()
                            )
                            return false
                        }
                    }
                }
                return true
            },
            handleRequest: function (args) {
                const self = this

                if (this.requestsDone.newPhysicalEvaluation) {
                    return handleAssets()
                }

                if (this.physicalEvaluationToSave) {
                    Api.editPhysicalEvaluation(JSON.parse(JSON.stringify(args.data)), function (response) {
                        if (response.success) {
                            self.requestsDone.newPhysicalEvaluation = response.data
                            handleAssets()
                        } else {
                            self.failed(response.message, args)
                        }
                    })
                } else {
                    Api.newPhysicalEvaluation(JSON.parse(JSON.stringify(args.data)), function (response) {
                        if (response.success) {
                            self.physicalEvaluationToSave = response.data
                            self.requestsDone.newPhysicalEvaluation = response.data
                            handleAssets()
                        } else {
                            self.failed(response.message, args)
                        }
                    })
                }

                function handleAssets() {
                    const data = self.requestsDone.newPhysicalEvaluation
                    const photos = self.getAssets('photos', data.id)

                    if (photos.length) {
                        sendPhotos(photos)
                    } else {
                        saved()
                    }

                    function sendPhotos(photos) {
                        if (!self.requestsDone.uploadedPhotos) {
                            self.requestsDone.uploadedPhotos = []
                        }
                        const clonePhotos = JSON.parse(JSON.stringify(photos))
                        let photosToSend = clonePhotos.filter(function (asset) {
                            return self.requestsDone.uploadedPhotos.indexOf(asset.photo) === -1
                        })

                        if (!photosToSend.length) {
                            return saved()
                        }
                        photosToSend = clonePhotos

                        if (self.physicalEvaluationToSave &&
                            self.physicalEvaluationToSave.photosIds &&
                            self.physicalEvaluationToSave.photosIds.length
                        ) {
                            Api.deletePhysicalEvaluationPhotos({
                                client_id: self.user.db_id,
                                pe_id: self.physicalEvaluationToSave.id,
                                ids: self.physicalEvaluationToSave.photosIds
                            }, function () {
                                sendNewPhotos()
                            })
                        } else {
                            sendNewPhotos()
                        }

                        function sendNewPhotos() {
                            Api.newPhysicalEvaluationPhotos({
                                client_id: self.user.db_id,
                                photos: photosToSend
                            }, function (response) {
                                if (response.success) {
                                    photosToSend.forEach(function (asset) {
                                        self.requestsDone.uploadedPhotos.push(asset.photo)
                                    })
                                    saved()
                                } else {
                                    self.failed(response.message, args)
                                }
                            })
                        }
                    }
                }

                function saved() {
                    checkProofStep(function () {
                        if (args.userDataToUpdate && !self.requestsDone.updateUser) {
                            if (args.userDataToUpdate.notes) {
                                args.userDataToUpdate.notes = self.encodeNotes(self.user.notes, args.userDataToUpdate.notes)
                            }
                            if (self.config.addUserTags) {
                                const tags = self.user.tags ? self.user.tags.split(',') : []
                                self.config.addUserTags.forEach(function (tag) {
                                    if (tags.indexOf(tag) === -1) {
                                        tags.push(tag)
                                    }
                                })
                                args.userDataToUpdate.tags = tags.join(',')
                            }
                            Api.updateUser(args.userDataToUpdate, function (response) {
                                if (response.success) {
                                    self.requestsDone.updateUser = true
                                    self.success(args.isSaveNext)
                                } else {
                                    self.failed(response.message, args)
                                }
                            })
                        } else {
                            self.success(args.isSaveNext)
                        }
                    })
                }

                function checkProofStep(cb) {
                    const proofStep = self.config.steps.find(function (p) {
                        return p.id === 'proof'
                    })
                    if (proofStep && proofStep.photos && proofStep.photos[0]) {
                        return Api.sendPayment({
                            id: self.user.db_id,
                            type: 0,
                            proof: proofStep.photos[0]
                        }, function (response) {
                            if (response.success) {
                                cb()
                            } else {
                                self.failed(response.message, args)
                            }
                        })
                    }
                    cb()
                }
            },
            encodeNotes: function (notes, newNotes) {
                try {
                    if (notes && newNotes) {
                        const notesParse = typeof notes === 'string' ? JSON.parse(notes) : notes
                        const newNotesParse = typeof newNotes === 'string' ? JSON.parse(newNotes) : newNotes
                        for (const key in newNotesParse) {
                            notesParse[key] = newNotesParse[key]
                        }
                        return JSON.stringify(notesParse)
                    }
                } catch (error) { }
                return newNotes
            },
            getAssets: function (type, registerId) {
                const assets = []
                for (let s = 0; s < this.config.steps.length; s++) {
                    const step = this.config.steps[s]
                    if (step.id === type) {
                        for (let p = 0; p < step[type].length; p++) {
                            if (step[type][p]) {
                                assets.push({
                                    pe_id: registerId,
                                    photo: step[type][p],
                                    type: type === 'photos' ? 0 : 1
                                })
                            }
                        }
                        break
                    }
                }
                return assets
            },
            success: function (isSaveNext) {
                const self = this
                this.processing = false
                if (isSaveNext) {
                    delete this.requestsDone.newPhysicalEvaluation
                    delete this.requestsDone.updateUser
                } else {
                    this.$isLoading(false)
                    let successMsg = this.config.successMessage ? (window.strings[this.config.successMessage] ? window.strings[this.config.successMessage] : this.config.successMessage) :window.strings['data_sent_successfully']
                    if (this.statusToSave === this.status.sendLater) {
                        successMsg = window.strings['data_saved_successfully']
                    }
                    this.$alert(
                        successMsg,
                        '',
                        'success',
                        Utils.getAlertOptions()
                    ).then(r => {
                        self.closeView()
                    })

                    if (this.config.send_success_message && this.statusToSave !== this.status.sendLater) {
                        Api.sendAppNotification({
                            pt_id: window.ptId,
                            title: '',
                            body: window.strings[this.config.send_success_message] ? window.strings[this.config.send_success_message] : this.config.send_success_message,
                            users: [this.user.id]
                        }, function (response) {
                            console.log('Client notification - ' + response.success)
                        })
                    }

                    if (this.config.hideButtonsAfterSubmit) {
                        this.hideButtons = true
                    }

                    if (this.config.showSuccessAfterSubmit) {
                        this.successAfterSubmitVisible = this.config.showSuccessAfterSubmit
                    }

                    if (this.config.showSuccessAfterSendLater && this.statusToSave === this.status.sendLater) {
                        this.successAfterSubmitVisible = this.config.showSuccessAfterSendLater
                    }

                    if (window.openedByDashboard) {
                        parent.postMessage(JSON.stringify({
                            event: 'physical-evaluation-created'
                        }), '*')
                    }
                }
            },
            failed: function (message, requestArgs) {
                const self = this
                this.$isLoading(false)
                this.processing = false
                this.$confirm(
                    message,
                    '',
                    'warning',
                    Utils.getAlertOptions({
                        confirmButtonText: window.strings['cancel'],
                        cancelButtonText: window.strings['try_again'],
                        confirmButtonColor: 'warning',
                        cancelButtonColor: 'success'
                    })
                ).then(() => { }).catch(() => {
                    self.processing = true
                    self.$isLoading(true)
                    self.handleRequest(requestArgs)
                })
            },
            showInfo: function (info) {
                this.$alert(
                    window.strings[info] ? window.strings[info] : info,
                    '',
                    'info',
                    Utils.getAlertOptions()
                )
            },
            openVideo: function (data) {
                if (data && data.video_url) {
                    this.videoOpened = {
                        name: data.name ? data.name : '',
                        video_url: Utils.getYoutubeEmbedUrl(data.video_url)
                    }
                    this.dialogVideo = true
                }
            },
            closeVideo: function () {
                this.videoOpened = null
                this.dialogVideo = false
            },
            selectButtonOption: function (item, value) {
                item.value = value
            },
            changeSlide: function (item, value) {
                item.value = item.items[value.currentSlide.index].value
            },
            closeSelect: function (id) {
                const select = this.$refs['component-multiselect-' + id] ? this.$refs['component-multiselect-' + id][0] : null
                if (select) {
                    select.blur()
                }
            },
            changeDatepickerInline: function (item) {
                item.value = this.datepickerInline.year + '-' + this.datepickerInline.month + '-' + this.datepickerInline.day
            },
            getDays: function () {
                const lastDay = new Date(this.datepickerInline.year, this.datepickerInline.month, 0).getDate()
                return Array.from({ length: lastDay }, (_, index) => {
                    const monthNumber = index + 1;
                    const monthValue = monthNumber < 10 ? `0${monthNumber}` : monthNumber.toString();
                    return { name: monthNumber, value: monthValue };
                })
            },
            getMonths: function () {
                const months = [
                    { name: 'jan', nameEn: 'jan', nameEs: 'ene', nameFr: 'janv', value: '01' },
                    { name: 'fev', nameEn: 'feb', nameEs: 'feb', nameFr: 'fév', value: '02' },
                    { name: 'mar', nameEn: 'mar', nameEs: 'mar', nameFr: 'mars', value: '03' },
                    { name: 'abr', nameEn: 'apr', nameEs: 'abr', nameFr: 'avr', value: '04' },
                    { name: 'mai', nameEn: 'may', nameEs: 'may', nameFr: 'mai', value: '05' },
                    { name: 'jun', nameEn: 'jun', nameEs: 'jun', nameFr: 'juin', value: '06' },
                    { name: 'jul', nameEn: 'jul', nameEs: 'jul', nameFr: 'juillet', value: '07' },
                    { name: 'ago', nameEn: 'aug', nameEs: 'ago', nameFr: 'août', value: '08' },
                    { name: 'set', nameEn: 'sep', nameEs: 'sep', nameFr: 'sept', value: '09' },
                    { name: 'out', nameEn: 'oct', nameEs: 'oct', nameFr: 'oct', value: '10' },
                    { name: 'nov', nameEn: 'nov', nameEs: 'nov', nameFr: 'nov', value: '11' },
                    { name: 'dez', nameEn: 'dec', nameEs: 'dic', nameFr: 'déc', value: '12' }
                ]
                switch (window.language) {
                    case 'en':
                        return months.map(month => ({ ...month, name: month.nameEn }))
                    case 'es':
                        return months.map(month => ({ ...month, name: month.nameEs }))
                    case 'fr':
                        return months.map(month => ({ ...month, name: month.nameFr }))
                    default:
                        return months.map(month => ({ ...month, name: month.name }))
                }
            },
            getYears: function () {
                const currYear = new Date().getFullYear()
                const lastYear = 1920
                return Array.from({ length: currYear - lastYear + 1 }, (_, index) => lastYear + index).reverse()
            },
            openSelectSearch: function (item) {
                const list = []
                let excludeItems = []
                if (item.excludeItems) {
                    const step = this.config.steps[this.stepIndex]
                    if (step && step.fields) {
                        step.fields.forEach(function (fd) {
                            if (item.excludeItems.indexOf(fd.id) > -1) {
                                if (fd.value) {
                                    if (fd.type === 'multiselect' || fd.type === 'multiselect_search') {
                                        excludeItems = excludeItems.concat(fd.value)
                                    } else {
                                        excludeItems.push(fd.value)
                                    }
                                }
                            }
                        })
                    }
                    excludeItems = [...new Set(excludeItems)]
                }
                let filterFieldToCompareValue = null
                for (let i = 0; i < item.items.length; i++) {
                    const clone = item.items[i]
                    clone.active = false
                    if (item.request && item.request.filter && item.request.filter.values && item.request.filter.values[clone.value]) {
                        if (!filterFieldToCompareValue) {
                            filterFieldToCompareValue = this.user[item.request.filter.fieldToCompare]
                        }
                        if (filterFieldToCompareValue && item.request.filter.values[clone.value].indexOf(filterFieldToCompareValue) > -1) {
                            continue
                        }
                    }
                    if ((item.type !== 'multiselect_search' && item.value === clone.value) ||
                        (item.type === 'multiselect_search' && item.value.indexOf(clone.value) > -1)
                    ) {
                        clone.active = true
                    }
                    clone.disabled = excludeItems.indexOf(clone.value) > -1 ? true : false
                    list.push(clone)
                }
                this.selectSearchItemsSearch = ''
                this.selectSearchItems = list
                this.updateMultiselectSearchField(item, {
                    opened: true
                })
            },
            closeSelectSearch: function (item) {
                this.updateMultiselectSearchField(item, {
                    opened: false
                })
                this.selectSearchItemsSearch = ''
                this.selectSearchItems = []
            },
            selectItemSelectSearch: function (field, item) {
                if (field.type === 'multiselect_search') {
                    const index = this.selectSearchItems.findIndex(function (it) {
                        return it.value === item.value
                    })
                    if (index > -1) {
                        this.selectSearchItems[index].active = !this.selectSearchItems[index].active
                        this.$set(this.selectSearchItems, index, this.selectSearchItems[index])
                    }
                } else {
                    for (let i = 0; i < this.selectSearchItems.length; i++) {
                        if (this.selectSearchItems[i].active && this.selectSearchItems[i].value !== item.value) {
                            this.selectSearchItems[i].active = false
                            this.$set(this.selectSearchItems, i, this.selectSearchItems[i])
                        }
                        if (this.selectSearchItems[i].value === item.value) {
                            this.selectSearchItems[i].active = true
                            this.$set(this.selectSearchItems, i, this.selectSearchItems[i])
                        }
                    }
                    this.confirmSelectSearch(field)
                }
            },
            confirmSelectSearch: function (item) {
                const selectedItems = []
                this.selectSearchItems.forEach(function (it) {
                    if (it.active) {
                        selectedItems.push(it.value)
                    }
                })
                this.updateMultiselectSearchField(item, {
                    opened: false,
                    value: item.type === 'multiselect_search' ? selectedItems : selectedItems[0]
                })
            },
            updateMultiselectSearchField: function (item, keys) {
                const index = this.config.steps[this.stepIndex].fields.findIndex(function (it) {
                    return it.id === item.id
                })
                if (index > -1) {
                    for (const key in keys) {
                        this.config.steps[this.stepIndex].fields[index][key] = keys[key]
                    }
                    this.$set(this.config.steps[this.stepIndex].fields, index, this.config.steps[this.stepIndex].fields[index])
                }
            },
            saveAudio: function (item, data) {
                item.value = data
            },
            clearAudio: function (item) {
                item.value = ''
            },
            updateTimepickerInlineValue: function (item, value) {
                item.value = value
            },
            onChangeCheckbox: function (item) {
                item.value = !item.value

                try {
                    if (item.actions) {
                        const action = item.actions.find(a => a.value === item.value)
                        if (action) {
                            for (let i = 0; i < this.config.steps.length; i++) {
                                if (this.config.steps[i].fields) {
                                    for (let f = 0; f < this.config.steps[i].fields.length; f++) {
                                        if (action.ids.includes(this.config.steps[i].fields[f].id)) {
                                            for (const key in action.fieldsToUpdate) {
                                                this.config.steps[i].fields[f][key] = action.fieldsToUpdate[key]
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch { }
            },
            closeView: function () {
                try {
                    if (window.physicalEvaluationToEdit) {
                        window.close()
                        return
                    }
                    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
                        window.ReactNativeWebView.postMessage(JSON.stringify({
                            event: 'close'
                        }))
                    }
                } catch { }
            },
            getDataCallbackReady: function (success, photosReady) {
                if (window.getDataCallback && (!this.getDataCallbackDone || !success)) {
                    if (success) {
                        for (let i = 0; i < this.config.steps.length; i++) {
                            if (this.config.steps[i].fields) {
                                for (let f = 0; f < this.config.steps[i].fields.length; f++) {
                                    if (this.config.steps[i].fields[f].items && !this.config.steps[i].fields[f].items.length) {
                                        return false
                                    }
                                }
                            }
                        }
                        if (photosReady) {
                            this.getDataCallbackPhotosReady = true
                        }
                    }
                    if (this.getDataCallbackPhotosReady || !success) {
                        this.getDataCallbackDone = true
                        parent.postMessage(JSON.stringify({
                            event: 'physical-evaluation-data',
                            data: success ? this.newPhysicalEvaluation(false, true) : 'error'
                        }), '*')
                    }
                }
            },
            handleFooterButton: function (action) {
                if (action === 'save') {
                    this.save()
                    return
                }
                if (action === 'next') {
                    this.nextStep()
                    return
                }
                if (action === 'back') {
                    this.backStep()
                    return
                }
            },
            copyTextToClipboard: function (event, text) {
                try {
                    if (navigator && navigator.clipboard) {
                        const textarea = document.createElement('textarea')
                        textarea.value = text
                        document.body.appendChild(textarea)
                        textarea.select()
                        document.execCommand('copy')
                        document.body.removeChild(textarea)
                        if (event) {
                            const element = event.currentTarget
                            if (element) {
                                element.style.color = '#888'
                                setTimeout(function () {
                                    element.style.color = ''
                                }, 300)
                            }
                        }
                    }
                } catch {}
            },
            openLinkUrl: function (url) {
                if (window.appReceiveLink) {
                    document.getElementById('link-view').setAttribute('data', url)
                    document.getElementById('link-view').click()
                } else {
                    window.open(url)
                }
            },
            getAverageValue: function (fields, item) {
                try {
                    const averageFields = fields.filter(field => field.average === item.average)
                    const last = averageFields[averageFields.length - 1]
                    if (last.id === item.id) {
                        const values = averageFields.filter(field => field.value)
                        const value = values.reduce((acc, field) => acc + parseFloat(field.value), 0) / values.length
                        console.log(value)
                        if (isNaN(value)) {
                            return null
                        }
                        return Math.round(value * 10) / 10
                    }
                } catch {}
                return null
            }
        },
    }
</script>